import {map} from 'lodash';

export const enUS = {
    confirm: 'Confirm',
    common: {
        replace: 'Replace',
        remove: 'Remove',
        optional: 'Optional',
    },
    login: {
        identifier: 'Identifier',
        password: 'Password',
        login: 'Login',
        verificationCodeFromSMS: 'Verification code you received by SMS',
        messageWasSentToSMS: (key, {last4digits}) => `An SMS message was sent to the phone number ending in ${last4digits}`,
        messageWasSentToEMAIL: (key, {maskedEmail}) => `An email was sent to ${maskedEmail}`,
        checkSpamMessage: 'If you cannot find the verification code, please check your',
        spamFolder: 'spam folder',
        validate: 'Validate',
        resendCode: 'Send again',
        sendCode: 'Send verification code',
        helloX: (key, {name}) => `Hello ${name}`,
        otpDeliveryMethod: 'How would you like to receive the verification code?',
        sendBySMS: 'SMS',
        sendByEmail: 'Email',
        sendByWhatsApp: 'WhatsApp',
        messageWasSentToWhatsApp: (key, {last4digits}) => `A WhatsApp message was sent to the phone number ending in ${last4digits}`,
        chooseVerificationMethod: 'Choose how you would like to receive the verification code:',
        noEmailContactManager: 'your email is not in system - contact your manager for help',
        noPhoneContactManager: 'your phone is not in system - contact your manager for help',
    },
    otpLogin: {
        sendToEmail: 'Email',
        sendToPhone: 'SMS',
        sendToWhatsApp: 'WhatsApp',
        emailAddress: 'Email Address',
        phoneNumber: 'Phone Number',
        phonePlaceholder: 'Enter phone number',
        invalidPhoneNumber: 'Invalid phone number',
        sendVerificationCode: 'Send Verification Code',
        title: 'Login with Verification Code',
        selectCompany: 'Select Company',
        selectCompanySubtitle: 'You are registered in multiple companies. Please select which company you want to log into:',
        backToContactInfo: 'Back to Contact Information',
    },
    changePassword: {
        currentPassword: 'Current Password',
        password: 'New Password',
        repeatPassword: 'Repeat new password',
        changePassword: 'Change Password',
        weakPassword: 'Password is too weak, it must contain at least one uppercase letter, one number, and be at least 8 characters long',
        newPasswordsDoesNotMatch: 'Passwords do not match',
        pleaseFillAllFields: 'Please fill in all required fields'
    },
    logout: 'Logout',
    menuItems: {
        logout: 'Logout',
        changePassword: 'Change Password',
        adminPanel: 'Admin Panel',
        home: 'Home Page',
        myOrgs: 'My Organizational Units',
        learningCenter: 'Learning Center',
        users: 'Users',
        reports: 'Reports',
        settings: 'Settings',
        learningManagement: 'Learning Management',
        filesManagement: 'Files Management',
        knowledgeCenter: 'Knowledge Center',
        operation: 'Operation',
        superAdmin: {
            courses: 'Courses Management',
            customers: 'Customers Management',
            organizations: 'Organizational Units Management',
            users: 'Users Management',
            dashboards: 'Reports',
            partners: 'Partners Management',
            assets: 'Assets Management',
            courseTemplates: 'Course Templates'
        },
    },
  routingTabs: {
      featureRequiredTooltip: (key, { tabName }) => `To enable the ${tabName} feature, please contact your learning developer or email info@weezbee.ai`
  },
    languages: {
        label: 'Choose Language',
        languageKeys: {
            heIL: 'עברית',
            enUS: 'English',
            arIL: 'العربية',
            ruRU: 'Русский',
            ptPT: 'Português'
        }
    },
    n8nChat: {
        title: 'Buzz AI',
        subtitle: 'Your WeezBee AI helper agent',
        greeting: 'Hi, I\'m Buzz AI - your WeezBee AI helper agent. How can I help you?',
        newConversation: 'New Conversation',
        inputPlaceholder: 'Send a message here...',
        closeChat: 'Close chat'
    },
    learningCenter: {
        title: 'My Learning Center',
        subTitle: 'Tasks and their completion status',
        loading: 'Loading tasks...',
        coursesToDo: 'Courses not yet completed',
        coursesCompleted: 'Courses I completed',
        noCoursesToDo: 'No courses not yet completed',
        noCoursesCompleted: 'No courses completed',

        // Generic sign docs (keep for backward compatibility)
        signDocsToDo: 'Documents to sign',
        signDocsCompleted: 'Documents I signed',
        noSignDocsToDo: 'No documents to sign',
        noSignDocsCompleted: 'No documents I have signed',

        // Archived SignDocs
        archivedSignDocs: 'Archived Tasks',
        noArchivedSignDocs: 'No archived tasks',
        versionsCount: (key, { count }) => `${count} versions`,
        versions: 'Versions',
        archivedVersions: 'Archived Versions',
        versionsNotFound: 'Versions not found',
        versionsNotFoundDescription: 'No archived versions found for this task',

        // Document specific titles - READ_AND_SIGN_DOC_PDF
        pdfDocsToDo: 'Documents to sign',
        pdfDocsCompleted: 'Documents I signed',
        noPdfDocsToDo: 'No documents to sign',
        noPdfDocsCompleted: 'No documents I have signed',

        // WATCH_AND_SIGN_YOUTUBE_LINK & WATCH_AND_SIGN_VIMEO_LINK
        videoLinksToDo: 'Videos to watch',
        videoLinksCompleted: 'Videos I watched',
        noVideoLinksToDo: 'No videos to watch',
        noVideoLinksCompleted: 'No videos I watched',

        // WATCH_AND_SIGN_VIDEO_FILE
        videoFilesToDo: 'Videos to watch',
        videoFilesCompleted: 'Videos I watched',
        noVideoFilesToDo: 'No videos to watch',
        noVideoFilesCompleted: 'No videos I watched',

        // REGULAR_COURSE
        regularCoursesToDo: 'Courses to complete',
        regularCoursesCompleted: 'Courses I completed',
        noRegularCoursesToDo: 'No courses to complete',
        noRegularCoursesCompleted: 'No courses I completed',

        // CANVA_PRESENTATION
        canvaPresentationsToDo: 'Presentations to watch',
        canvaPresentationsCompleted: 'Presentations I watched',
        noCanvaPresentationsToDo: 'No presentations to watch',
        noCanvaPresentationsCompleted: 'No presentations I watched',

        // EXAM
        examsToDo: 'Exams not yet completed',
        examsCompleted: 'Exams I completed',
        noExamsToDo: 'No exams not yet completed',
        noExamsCompleted: 'No exams I completed',

        // LEARNING_PATH
        learningPathsToDo: 'Learning paths not yet completed',
        learningPathsCompleted: 'Learning paths I completed',
        noLearningPathsToDo: 'No learning paths not yet completed',
        noLearningPathsCompleted: 'No learning paths I completed',

        // PODCAST
        podcastsToDo: 'Podcasts to listen to',
        podcastsCompleted: 'Podcasts I listened to',
        noPodcastsToDo: 'No podcasts to listen to',
        noPodcastsCompleted: 'No podcasts I listened to',

        // AUDIO_FILE
        audioFilesToDo: 'Audio files to listen to',
        audioFilesCompleted: 'Audio files I listened to',
        noAudioFilesToDo: 'No audio files to listen to',
        noAudioFilesCompleted: 'No audio files I listened to',

        // FRONTAL_COURSE
        frontalCoursesToDo: 'Frontal lectures to attend',
        frontalCoursesCompleted: 'Frontal lectures I attended',
        noFrontalCoursesToDo: 'No frontal lectures to attend',
        noFrontalCoursesCompleted: 'No frontal lectures I attended',

        // ONLINE_COURSE
        onlineCoursesToDo: 'Online courses to complete',
        onlineCoursesCompleted: 'Online courses I completed',
        noOnlineCoursesToDo: 'No online courses to complete',
        noOnlineCoursesCompleted: 'No online courses I completed',

        // PRESENTATION
        presentationsToDo: 'Presentations to watch',
        presentationsCompleted: 'Presentations I watched',
        noPresentationsToDo: 'No presentations to watch',
        noPresentationsCompleted: 'No presentations I watched',

        // ARTICLE
        articlesToDo: 'Articles to read',
        articlesCompleted: 'Articles I read',
        noArticlesToDo: 'No articles to read',
        noArticlesCompleted: 'No articles I read',

        // SURVEY
        surveysToDo: 'Surveys to complete',
        surveysCompleted: 'Surveys I completed',
        noSurveysToDo: 'No surveys to complete',
        noSurveysCompleted: 'No surveys I completed',

        // LINK
        linksToDo: 'Links to visit',
        linksCompleted: 'Links I visited',
        noLinksToDo: 'No links to visit',
        noLinksCompleted: 'No links I visited',

        // UPLOAD_DOCUMENT
        uploadsToDo: 'Documents to upload',
        uploadsCompleted: 'Documents I uploaded',
        noUploadsToDo: 'No documents to upload',
        noUploadsCompleted: 'No documents I uploaded',

        noOpenTasks: 'No open tasks',

        // Existing learningCenter translations continue
        tabs: {
            myCourses: 'My Courses',
            courses: 'Frontal & Online Trainings',
            mySignDocs: 'Documents to Sign',
            myTasks: 'Open Tasks',
            myCertifications: 'Certifications',
            myExams: 'Exams',
            myWeezbeeCourses: 'Courses',
            learningPaths: 'Learning Paths',
            myVideos: 'Videos',
            myAudioFiles: 'Audio Files',
            myPresentations: 'Presentations',
            myLinks: 'Links',
            surveys: 'Surveys',
            myContent: 'My Content',
            archived: 'Archive',
        },
        searchMyContent: 'Search My Content',
        searchMyContentPlaceholder: 'Search by name...',
        filterByType: 'Filter by Type',
        uploads: 'Document Uploads',
    },
    settingsPage: {
        title: 'Settings',
        subTitle: 'Adjust the system',
        subTitleBold: `to your company's needs`,
        buttons: {
            updateLogo: "Update Logo",
            updateOrgName: "Update Organizational Units Names",
            addOrg: "Add Organizational Units",
            updateNotes: "Update Notes for Employees",
            adminInstructionCourse: "Administrator Instruction Course",
        },
        editNotesModal: {
            title: 'Edit Notes for Employees',
        },
        addOrganizationModal: {
            organizationsList: 'List of Organizational Units',
            useCommaSeparatedValues: 'Enter comma-separated values, for example: "Finance, Accounting, Software Development"',
            title: 'Add Organizational Units',
        },
        editOrganizationsNames: 'Edit Organizational Units Names',
        createNote: 'Create New Note',
        newNoteTitle: 'New Note',
        SMSQuota: {
            title: 'Messages Credit',
            quota: 'Purchased Messages',
            sent: (key, {
                sent,
                quota
            }) => `For your information, up to now ${sent} messages were sent and you have ${quota} messages left for future use`,
            lastSMSWasSentOn: (key, {date}) => `The last messages were sent from the system on the date ${date}`,
        },
        generalSettings: {
            title: 'General'
        },
        reminders: {
            title: 'Reminders',
            course: 'Course',
            signDoc: 'Document to Sign',
            watchVideo: 'Watch a Video',
            listenAudio: 'Listen to Audio File',
            canvaPresentation: 'View a Canva',
            exam: 'Exam',
            learningPath: 'Learning Path',
            link: 'Link',
            survey: 'Survey',
            weezbeeCourse: 'Online Course',
            frontalCourse: 'Frontal Course',
            onlineCourse: 'Online Course',
            uploadDocument: 'Document Upload',
        },
        admins: {
            title: 'Admins',
            subTitle: 'Management and Settings'
        },
        setup: {
            title: 'Setup Settings'
        },
        deletedUsers: {
            title: 'Deleted Users'
        },
        organizationalUnits: {
            title: 'Organizational Units',
        }
    },
    HomePage: {
        courseLegend: {
            completed: 'Completed',
            inProgress: 'In Progress',
            notStarted: 'Not Started'
        },
    },
    home: {
        title: 'Available Courses for You',
        faq: 'Frequently Asked Questions',
        welcome: 'Welcome',
        // learningSubtitle:(key,{companyName}) => `לסביבת הלמידה האישית שלכם, עבור חברת ${companyName}`,
        learningSubtitle: "To your personal learning environment, for",
        userChartLabels: {
            finishedCourses: 'Courses I completed',
            inProgressCourses: 'Courses in progress',
            notStartedCourses: 'Courses not started',
            label: 'Courses Progress'
        },
        superAdmin: 'System Admin Interface',
    },
    faq: {
        question1: 'Can I return to the courses at any time?',
        answer1: 'Yes. You can learn at your own pace from anywhere, at any time, from your mobile phone or computer (we recommend opening in Google Chrome). Note that once you start a course, you must complete it on the same device.',
        question2: 'What do I do when I finish the courses?',
        answer2: 'When you complete a course, click the Finish button and confirm that you have completed the course. Make sure there are no open tasks left.',
        question3: 'Need help?',
        answer3: 'Feel free to contact us by phone at 052-9663062, or via email at info@nakarmedic.co.il',
    },
    gender: {
        male: 'Male',
        female: 'Female'
    },

    OrganizationsPage: {
        title: 'My Organizational Units',
        subTitle: 'Management and Settings',
        organizations: 'Organizational Units I Manage',
        importUsersFile: "Import Users File",
        editLogo: 'Edit Logo',
        dropLogoHere: 'Drag the logo here',
        currentLogo: 'Current Logo',
        changeForAllMyOrganizations: 'Change for all Organizational Units I manage',
        logoWillBeChangedForAllOrgs: '**The logo will be changed for all organizational units under your management',
    },
    UsersPage: {
        title: 'Users',
        subTitle: 'Management and Settings',
        userRowCourseMenu: {
            buttons: {
                addToCourse: 'Register User',
                removeFromCourse: 'Remove User Registration',
            }
        },
        userRowSignDocMenu: {
            buttons: {
                addToSignDoc: 'Register User',
                removeFromSignDoc: 'Remove Registration',
                markCompleted: 'Mark as Completed',
                unmarkCompleted: 'Unmark as Completed',
            },
            tooltips: {
                sessionNotToday: 'Attendance can only be marked on the day of the session'
            }
        }
    },
    organizationUserTable: {
        headers: {
            name: "Name",
            permissions: "Permission",
            identifier: "Identifier"
        }
    },
    userType: {
        ADMIN: 'Admin',
        USER: "User"
    },
    note: {
        title: 'Title',
        content: 'Content',
        delete: 'Delete Note',
        assignToAllOrganizations: 'Assign to All Organizational Units',
        removeFromAllOrganizations: 'Remove from All Organizational Units',
        deleteNoteConfirmation: {
            title: 'Delete Note',
            message: 'Are you sure you want to delete the note?',
            noteName: 'Note Name',
            deleteNote: 'Delete Note'
        }
    },
    organization: {
        organizationName: 'Organizational Unit Name',
    },
    courseCard: {
        youAreDone: `You have completed the course`,
        finishBy: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
        youAreDoneWatchAgain: 'Watch Again',
        goToCourse: 'Go to Course'
    },
    courseProgress: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        finished: 'Finished!',
    },
    ReportsPage: {
        title: 'Reports',
        subTitle: 'View employees completion status',
        subTitleBold: 'in a graphical display.',
        courseLegend: {
            completed: 'Completed',
            inProgress: 'In Progress',
            notStarted: 'Not Started'
        },
        coursesStats: {
            title: 'Completion status for each course',
        },
        signDocStats: {
            title: {
                course: 'Completion status for each course',
                signDocs: 'Signature status for each document'
            },
            exportToExcel: 'Export to Excel',
            exporting: 'Exporting...',
            exportCurrentFilters: 'Export current filters',
            graphs: {
                usersPerformanceNumbers: (key, {taskCount = 0}) => `Number of users by completion status ${taskCount ? `(${taskCount} tasks)` : ''}`,
                usersPerformancePercent: (key, {taskCount = 0}) => `Percentage of users by completion status ${taskCount ? `(${taskCount} tasks)` : ''}`,
                performanceNumberByOrg: (key, {orgsCount = 0}) => `Number of completions in the organizational unit ${orgsCount ? `(${orgsCount} organizational units)` : ''}`,
                performancePercentByOrg: (key, {orgsCount = 0}) => `Completion percentage in the organizational unit ${orgsCount ? `(${orgsCount} organizational units)` : ''}`,
                signDocsCount: ' Documents to sign',
                activeCourseCount: 'Active Learning Items',
                usersCount: 'Users',
                usersWithActiveTasks: 'Users with an active task',
                allSignDocsOfACompanyCount: 'Learning and Training Items',
                examPassRate: 'Exam pass/fail rate',
                examPassCountRate: 'Number of exam pass/fail',
                info: {
                    activeCourseCount: 'Total learning items with a future end date (courses, documents to sign, and viewing tasks)',
                    usersCount: 'Total users',
                    usersWithActiveTasks: 'Total users with at least one active task',
                    allSignDocsOfACompanyCount: 'Total learning items (courses, documents to sign, and viewing tasks)',
                    performanceNumberByOrg: 'Total completed tasks out of all accumulated tasks\n (Accumulated tasks = number of learning and training items multiplied by the number of users assigned to each item)',
                    performancePercentByOrg: 'Total tasks completed in each organizational unit',
                    examPassRate: 'Total users who passed/failed the exam out of users who completed the exam',
                    examPassCountRate: 'Total users who passed/failed the exam out of all users who completed the exam',
                }
            }
        },
        tabs: {
            dashboard: 'Dashboard',
            allReports: 'Learning and Training Reports',
            courses: 'Courses',
            signDocs: 'Documents to Sign',
            exams: 'Exams',
            learningPaths: 'Learning Paths',
            surveys: 'Surveys',
            courseReports: 'Frontal & Online Trainings',
            userProgress: 'User Progress',
            certifications: 'Certifications',
            generatedReports: 'Generated Reports',
            videos: 'Video',
            KnowledgeCenter: 'Knowledge Center',
            operation: 'Operation',
            audioFiles: 'Audio Files',
            presentations: 'Presentations',
            links: 'Links',
        }
    },
    surveyReports: {
        title: 'Survey Reports',
        subtitle: (key, { count }) => `Showing ${count} surveys with response data`,
        card: {
            progress: 'Progress',
            type: 'Type',
            actions: 'Actions',
            anonymous: 'Anonymous',
            identified: 'Identified',
            viewFullReport: 'View Report',
            responseRate: 'Response Rate',
            assignedTo: 'Assigned to Organizations',
            assigned: 'Assigned',
            noOrganizations: 'No specific organizations',
        },
        noSurveys: {
            title: 'No surveys to display',
            message: 'No surveys found in the selected organizational unit. Try selecting a different organizational unit or create a new survey.'
        }
    },
    surveyCharts: {
        chartType: {
            bar: 'Bars',
            pie: 'Pie'
        },
        metadata: {
            totalResponses: (key, { count }) => `Total responses: ${count}`,
            responseFromUsers: (key, { responses }) => `${responses} responses`,
            questionType: (key, { type }) => `Question type: ${type}`,
            anonymous: 'Anonymous'
        },
        noData: {
            title: 'No data to display for this question',
            message: 'No responses found for this question'
        },
        tooltips: {
            responses: 'Responses',
            responseCount: (key, { count }) => `${count} responses`,
            percentage: (key, { percent }) => `${percent}%`
        }
    },
    courseReports: {
        title: 'Course Reports',
        defaultTitle: 'Course',
        subtitle: (key, { completed, assigned, rate }) => `${completed} out of ${assigned} completed (${rate}%)`,
        organization: 'Organizational Unit',
        allOrganizations: 'All Organizational Units',
        completed: 'Completed',
        notFound: 'Course not found',
        card: {
            sessionDate: 'Session Date',
            noSessionDate: 'No date set',
            viewFullReport: 'View Full Report',
            completionRate: 'Completion Rate'
        },
        downloadReport: 'Download Tasks Report',
        noCourses: {
            title: 'No Courses Available',
            message: 'No courses found for the selected organizational units'
        }
    },
    signDocReports: {
        searchLabel: 'Search',
        searchPlaceholder: 'Search by name...',
        filterByType: 'Filter by Content Type',
        noSignDocs: {
            title: 'No Content Available',
            message: 'No content found for the selected organizational units'
        }
    },
    surveyResults: {
        title: 'Survey Results',
        organization: 'in organizational unit',
        allOrganizations: 'in all organizational units',
        subtitle: (key, { responses, assigned, rate }) => `${responses} out of ${assigned} responded (${rate}%)`,
        backToSurveys: 'Back to survey list',
        questionsTitle: 'Question Results',
        questionNumber: (key, { number }) => `Question ${number}`,
        freeTextDefault: (key, { count }) => `Received ${count} free text responses`,
        notFound: 'Survey not found',
        defaultTitle: 'Survey Results',
        freeTextResponses: {
            title: 'Free Text Responses',
            noResponses: 'No free text responses received for this question'
        },
        meta: {
            organization: 'Organizational Unit',
            totalQuestions: 'Number of Questions',
            type: 'Survey Type',
            completionRate: 'Completion Rate'
        },
        tabs: {
            results: 'Survey Results',
            users: 'Users',
            generatedReports: 'Generated Reports',
            KnowledgeCenter: 'Knowledge Center'
        }
    },
    learningPathReport: {
        status: {
            completed: 'Completed',
            inProgress: 'In Progress',
            notStarted: 'Not Started'
        }
    },
    surveyUsers: {
        columns: {
            fullName: 'Full Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            identifier: 'Identifier',
            status: 'Status',
            idNumber: 'ID Number',
            employeeId: 'Employee ID',
            showUserAnswer: 'Show Answers'
        },
        actions: {
            showAnswer: 'Show Answers'
        },
        noUsers: {
            title: 'No users to display',
            message: 'No users found for the survey in the selected organizational unit.'
        }
    },
    userSurveyAnswers: {
        modalTitle: (key, { userName }) => `User ${userName} responses`,
        columns: {
            question: 'Question',
            questionType: 'Question Type',
            userAnswer: 'User Answer',
            isCorrect: 'Correct'
        },
        notApplicable: 'Not applicable',
        noAnswer: 'Not answered',
        unknownQuestion: 'Unknown question',
        unknownQuestionType: 'Unknown question type',
        unknownOption: 'Unknown option',
        invalidRating: 'Invalid rating',
        loading: 'Loading responses...',
        error: 'Error loading responses',
        noQuestions: 'No questions found'
    },
    courseProgressMgmnt: {
        notStarted: 'Not Started',
        inProgress: 'In Progress',
        finished: 'Completed',
        attended: 'Attended',
        noShow: 'No Show',
        registered: 'Registered',
        completedOn: 'Signature Date: ',
        completedOnCourse: 'Completion Date: ',
        by: 'by ',
        manual: 'Manual',
        finishBy: 'To be completed by: ',
        score: 'Score',
    },
    examScore: 'Score',
    LearningManagementPage: {
        title: 'Learning Management',
        subTitle: 'Add, edit, and delete',
        addCourse: 'Add Course',
        editCourse: 'Edit Course',
        deleteCourse: 'Delete Course',
        courseName: 'Course Name',
        courseDescription: 'Course Description',
        courseImage: 'Course Image',
        createKnowledgeSource: 'Create Knowledge Source',
        createQuestionnaire: 'Create questionnaire',
        createExam: 'Create an Exam',
        createLearningPath: 'Create Learning Path',
        courseCard: {
            editCourse: 'Edit Course',
        },
        signDocCard: {
            editSignDoc: {
                READ_AND_SIGN_DOC_PDF: 'Edit Document',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Edit Viewing Task',
                WATCH_AND_SIGN_VIMEO_LINK: 'Edit Viewing Task',
                WATCH_AND_SIGN_VIDEO_FILE: 'Edit Viewing Task',
                AUDIO_FILE: 'Edit Listening Task',
                REGULAR_COURSE: 'Edit Course',
                CANVA_PRESENTATION: 'Edit Presentation',
                EXAM: 'Edit exam',
                LEARNING_PATH: 'Edit Learning Path',
                LINK: 'Edit Link for Viewing',
                SURVEY: 'Edit Survey',
                FRONTAL_COURSE: 'Edit Frontal Lecture',
                ONLINE_COURSE: 'Edit Online Course',
            },
            deleteModal: {
                title: 'Delete Document',
                text: 'Are you sure you want to delete this document? This action cannot be undone',
                confirm: 'Delete Document',
                cancel: 'Cancel',
                signDocName: 'Document Name',
                deleteAllVersionsCheckbox: 'Delete all versions of this document',
                warningAllVersions: '⚠️ Warning: Deleting this document will delete all versions of the document'
            },
            versionManagement: 'Version Management',
            uplodingSignDoc: {
                uploadInProgress: 'File upload in progress',
                uploadFailed: 'Upload process failed'
            }
        },
        users: {
            buttons: {
                downloadCsv: 'Download',
                downloadCsvForOrganizations: 'Download tasks report for users from selected organizational units',
                downloadUserDetailsForOrganizations: 'Download user details file for selected organizational units',
                downloadSelectedUsers: 'Download Tasks Report for Selected Users',
                downloadCsvForOrganization: 'Download users file for selected organizational unit',
                downloadCsvForAllOrganizations: 'Download users file for all organizational units I manage',
            },
            messages: {
                exportStarted: 'Export started. Navigating to Reports...',
                exportFailed: 'Export failed. Please try again.',
                noUsersSelected: 'Please select users to export',
            }
        },
        courseManagement: 'Courses Management',
        signDocManagement: 'Documents Management',
        noSignDocs: 'No documents to display',
        noSearchResults: 'No results found for your search',
        noSearchResultsHint: 'Try adjusting your search term or clear the search to see all items',
        tabs: {
            signDocs: 'Documents to Sign',
            courses: 'Courses',
            users: 'Users',
            certifications: 'Certifications',
            pendingApprovals: 'Documents for Approval',
            courseAttendance: 'Course Attendance',
            tasks: 'Tasks',
            knowledgeCenter: 'Knowledge Center',
            operation: 'Operation',
            exams: 'Exams',
            learningPath: 'Learning Paths/ Training',
            videoLinks: 'Videos',
            audioFiles: 'Audio Files',
            presentations: 'Presentations',
            links: 'Links',
            surveys: 'Surveys',
            uploads: 'Upload Documents',
            frontalCourses: 'Frontal Lectures',
            onlineCourses: 'Online Courses',
            archive: 'Archive',
        },
        searchTasks: 'Search Tasks',
        searchTasksPlaceholder: 'Search by name...',
        filterByType: 'Filter by Type',
        filterByTypePlaceholder: 'Select types...',
        allTypes: 'All Types',
        typeNames: {
            READ_AND_SIGN_DOC_PDF: 'Documents to Sign',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Videos',
            WATCH_AND_SIGN_VIMEO_LINK: 'Videos',
            WATCH_AND_SIGN_VIDEO_FILE: 'Videos',
            VIDEOS: 'Videos',
            REGULAR_COURSE: 'Courses',
            CANVA_PRESENTATION: 'Presentations',
            EXAM: 'Exams',
            LEARNING_PATH: 'Learning Paths',
            SURVEY: 'Surveys',
            ARTICLE: 'Articles',
            AUDIO_FILE: 'Audio Files',
            LINK: 'Links',
            PODCAST: 'Podcasts',
            FRONTAL_COURSE: 'Frontal Courses',
            ONLINE_COURSE: 'Online Courses',
            PRESENTATION: 'Presentations',
            WEEZBEE_COURSE: 'Courses',
            UPLOAD_DOCUMENT: 'Upload Documents',
        },
        addLearningObject: 'Add Learning \nand Training Items',
        honeycombTitle: 'Learning and Training Items',
    },
    signDocVersionManagement: {
        title: 'Version Management',
        managingVersionsFor: 'Managing versions for',
        createNewVersionButton: 'Create New Version',
        allVersions: 'All Versions',
        archive: 'Archive',
        currentVersion: 'Current Version',
        versionNumber: 'Version Number',
        versionDetails: 'Version Details',
        viewDetails: 'View Details',
        errorTitle: 'Error Loading Versions',
        notFound: 'Document Not Found',
        notFoundDescription: 'The document you are looking for does not exist or has been removed',
        noVersions: 'No versions to display',
        created: 'Created',
        createdBy: 'Created by',
        expiredAt: 'Expired at',
        type: 'Type',
        status: {
            label: 'Status',
            ACTIVE: 'Active',
            ARCHIVED: 'Archived',
            SCHEDULED: 'Scheduled'
        },
        toggleStatus: 'Click to toggle status (Active/Archived)',
        stats: {
            assigned: 'Assigned',
            completed: 'Completed',
            inProgress: 'In Progress',
            completionRate: 'Completion Rate',
            totalUsers: 'Total Users'
        },
        statistics: {
            progressDone: 'Progress Done',
            usersAssigned: 'Users Assigned',
            usersCompleted: 'Users Completed',
            usersInProgress: 'Users In Progress'
        },
        viewStatistics: 'View Statistics',
        userStatistics: 'User Statistics',
        returnToData: 'Return to Data',
        goToReports: 'Go to Reports',
        edit: 'Edit',
        preview: 'Preview',
        tabs: {
            versions: 'Versions',
            recurringDetails: 'Recurring Details'
        },
        recurring: {
            title: 'Recurring Configuration',
            notConfigured: 'This document is not configured for recurring',
            frequency: 'Recurring Frequency',
            nextVersionDate: 'Next Version Date',
            editNextVersionDate: 'Edit next version date',
            changeDate: 'Change date',
            everyXMonths: (key, { value }) => `Every ${value} month${value === 1 ? '' : 's'}`,
            everyXYears: (key, { value }) => `Every ${value} year${value === 1 ? '' : 's'}`,
            badge: 'Recurring',
        }
    },
    signDocPreviewPage: {
        title: 'Content Preview',
        loading: 'Loading preview...',
        errorTitle: 'Preview Error',
        errorDescription: 'Unable to load the content preview. The document may not have any uploaded content yet.',
        noContent: 'No previewable content available for this document.',
        backToVersions: 'Back to Versions',
    },
    editCourseModal: {
        title: 'Edit Course',
        courseName: 'Course Name',
        courseDescription: 'Course Description',
        courseImage: 'Course Image',
        save: 'Save Changes',
        edit: {
            courseName: 'Course Name',
            courseDescription: 'Course Description',
            dateEditNotification: 'You can set a unified end date for all users registered for the course in all the organizational units you manage. Any changes you make here will override individual changes made for users.'
        },
        dateModal: {
            title: 'Set End Date',
            timeAndTimezone: 'Until 00:00 in time zone: '
        }
    },
    editUserCourseModal: {
        title: (key, {userName, courseName}) => `Set an end date for course "${courseName}" for user "${userName}"`,
        dateEditNotification: 'You can set an end date for the user. This change will remain in effect unless you change the end date for the entire organizational unit.'
    },
    AppSideMenu: {
        welcome: `Welcome`,
        legalLinks: {
            termsOfUse: 'Terms of Use',
            privacyPolicy: 'Privacy Policy'
        }
    },
    superAdmin: {
        partnersTable: {
            columns: {
                clientSecretExpiresAt: 'Client Secret Expires',
            }
        },
        cronJobs: {
            sectionTitle: 'Cron Jobs',
            runRecurringRenewal: 'Run Recurring Renewal',
            running: 'Running...',
            renewalSuccess: 'Recurring renewal completed successfully',
            renewalError: 'Recurring renewal failed. Check server logs.',
        },
        generateAPIKeyModal: {
            generateAPIKey: 'Generate API Key',
            modalTitle: 'API Key',
        },
        generateClientCreds: {
            generateClientCreds: 'Generate Client Credentials',
            modalTitle: 'Client Credentials',
            clientId: 'Client ID',
            clientSecret: 'Client Secret'
        },
        editPartnerCompaniesModal: {
            modalTitle: 'Edit Partner Companies',
            selectAllCompanies: 'Select All Companies',
            selectCompanies: 'Select Companies',
            save: 'Save Companies'
        },
        assets: {
            title: 'Assets Management',
            columns: {
                fileName: 'File Name',
                type: 'Type',
                company: 'Company',
                createdBy: 'Created By',
                tags: 'Tags',
                lastModified: 'Last Modified',
                download: 'Download',
                thumbnail: 'Preview'
            },
            filters: {
                companyName: 'Company Name',
                type: 'File Type',
                all: 'All',
                image: 'Image',
                video: 'Video',
                clear: 'Clear Filters',
                generalBank: 'General Bank'
            },
            fileTypes: {
                image: 'Image',
                video: 'Video',
                file: 'File'
            },
            download: 'Download File',
            downloadError: 'Error downloading file',
            loading: 'Loading...',
            thumbnailError: 'Error loading preview',
            thumbnail: 'File preview',
            upload: {
                title: 'Upload to General Bank',
                uploadButton: 'Upload Asset',
                cancel: 'Cancel',
                upload: 'Upload',
                dragDrop: 'Drag and drop a file here or click to select a file',
                supportedTypes: 'Supported file types: Images (.jpg, .png, .gif) and Videos (.mp4, .mov, .avi)',
                presentationName: 'Display Name',
                presentationNamePlaceholder: 'Enter a name for the file',
                description: 'Description',
                descriptionPlaceholder: 'Enter a description for the file',
                noFileSelected: 'Please select a file to upload',
                error: 'An error occurred while uploading the file',
                uploading: 'Uploading'
            },
            tags: {
                editTags: 'Edit Tags',
                enterTagsPlaceholder: 'Enter tags separated by commas',
                tagsHelperText: 'Tags help organize and find assets more easily',
                andMoreTags: (key, { count }) => `and ${count} more`,
                noTags: 'No tags',
                save: 'Save',
                cancel: 'Cancel'
            }
        },
        courseTemplates: {
            title: 'Course Templates',
            placeholder: 'Course templates functionality is coming soon. This page will allow you to create, edit, and manage course templates that can be used across the platform.',
            columns: {
                templateName: 'Template Name',
                templateSubject: 'Subject',
                description: 'Description',
                createdBy: 'Created By',
                isPubliclyAccessible: 'Publicly Accessible',
                isReady: 'Ready',
                actions: 'Actions'
            },
            buttons: {
                createTemplate: 'Create New Template',
                editTemplate: 'Edit Template',
                duplicateTemplate: 'Duplicate Template',
                deleteTemplate: 'Delete Template',
                viewTemplate: 'View Template'
            },
            searchPlaceholder: 'Search templates...',
            noTemplates: 'No templates found. Create your first template by clicking the button above.',
            fetchError: 'Failed to load templates. Please try again later.',
            searchError: 'Failed to search templates. Please try again later.',
            deleteError: 'Failed to delete template. Please try again later.',
            confirmDelete: 'Are you sure you want to delete this template?'
        },
        editFFModal: {
            modalTitle: "Edit Company Features",
            editFeatures: "Edit Features",
            paths: {
                basic: 'Basic',
                creator: 'Creator',
                enterprise: 'Enterprise'
            },
            deals: {
                messaging: 'Messaging & Communication',
                contentTypes: 'Content Types',
                courses: 'Courses & Training',
                automation: 'Automation',
                advanced: 'Advanced Features',
                organization: 'Organization Management',
                system: 'System Settings'
            },
            dealStatus: {
                allEnabled: 'All Enabled',
                partiallyEnabled: 'Partially Enabled',
                disabled: 'Disabled'
            },
            featureFlags: {
                automationFF: 'Automation',
                smsFF: 'SMS',
                whatsappFF: 'Whatsapp',
                emailFF: 'Email',
                signDocsFF: 'Tasks',
                sendWelcomeMessageFF: 'Send New User Messages',
                signDocsReadAndSignDocPdfFF: 'Sign PDF',
                signDocsWatchAndSignYoutubeLinkFF: 'Confirm Youtube Viewing',
                signDocsWatchAndSignVimeoLinkFF: 'Confirm Vimeo Viewing',
                signDocsWatchAndSignVideoFileFF: 'Confirm Video File Viewing',
                signDocCanvaPresentationFF: 'Canva Presentation',
                regularCourseFF: 'Courses',
                frontalCourseFF: 'Frontal Trainings',
                onlineCourseFF: 'Online Trainings',
                notifyNewTaskToUserFF: 'Notify New Task to User',
                knowledgeCenterFF: 'Knowledge Center',
                orgAdminMgmtFF: 'Admin Permissions Management',
                subAdminCanCreateOrgFF: 'Sub-Admin Can Create Organizations',
                languagesFF:'Languages',
                examsFF: 'Exams',
                AIFF: 'AI',
                learningPathFF: 'Learning Path',
                signDocsAudioFileFF: 'Audio File',
                linkFF: 'Links',
                surveyFF: 'Surveys',
                recurringAutomationFF: 'Recurring Automation',
                weezbeeCourseFF: 'WeezBee Course',
                uploadDocumentFF: 'Upload Documents',
                certificationFF: 'Certifications',
                phoneE164MigrationFF: 'Phone E.164 Format Migration',
                bulkUserRefactorFF: 'Bulk User Refactor V2',
                operationModeFF: 'Operation Mode (Rename Knowledge Center)',
                mustDoComplianceFF: 'Mandatory Compliance'
            }
        },
        allUsersTable: {
            columns: {
                firstName: 'First Name',
                lastName: 'Last Name',
                email: 'Email',
                phone: 'Phone',
                roles: 'Roles',
                identifier: 'Identifier',
                organization: 'Organizational Unit',
                id: 'ID',
                companyName: 'Company',
                yes: 'Yes',
                no: 'No',
                isSuperAdmin: 'System Admin',
                isCompanyAdmin: 'Company Admin',
                isDeleted: 'Deleted',
                deleted: 'Deleted',
                edit: 'Edit',
                permanentlyDelete: 'Permanent Deletion',
                loginUrl: 'Login Link',
                userCreatedSmsDate: 'Welcome SMS Date',
                loginAs: 'Login As',
            },
            buttons: {
                downloadCsvForOrganization: 'Download Excel file for organizational unit',
                downloadCsvForAllOrganizations: 'Download Excel files for all organizational units I manage',
                downloadCsvForOrganizationSuccess: 'Your files will be ready for download soon under "Menu -> Files Management"',
                deleteUsers: 'Delete Users',
                edit: 'Edit',
            }
        },
        allOrgsTable: {
            columns: {
                orgName: 'Organizational Unit Name',
                taxIdentifier: 'Identifier',
                companyId: 'Company ID',
                orgAddress: 'Address',
                orgContactInfo: 'Contact Info',
                id: 'ID',
                companyName: 'Company Name',
                delete: 'Delete',
            },
            deleteOrg: 'Delete Organizational Unit',
            deleteOrgTitle: 'Delete Organizational Unit: ',
            deleteOrgText: 'Are you sure you want to delete the organizational unit',
            deleteOrgConfirm: 'Delete Organizational Unit',
        },
        createNewCourse: {
            title: 'Create a New Course',
            docName: 'Course Name',
            courseDescription: 'Course Description',
            create: 'Create Course',
            companyName: 'Company Name',
            dropZipHere: 'Drag the course zip file here or click to select a file',
            modalTitle: 'Create a New Course',
            assignToAllOrganizations: 'Assign to All Organizations',
            assigned: 'Successfully assigned to all organizations',
            organizationsTable: {
                orgName: 'Organizational Unit Name',
                addOrganization: 'Add Course to the Organizational Unit',
                removeOrganization: 'Remove Course from the Organizational Unit',
                onlyOneCompanyPerCourse: 'A course can only be added to one company, so you cannot change the company selection now',
            }
        },

        createNewCustomer: {
            modalTitle: 'Create a New Customer',
            companyName: 'Company Name',
            userPrefix: 'User Prefix (unique for each company - English only)',
            identifier: 'Identifier',
            contactEmail: 'Contact Email',
            contactName: 'Contact Name',
            contactPhone: 'Contact Phone',
            userCreationTitle: 'Create an initial company user',
            detailsTitle: 'Fill in the company details',
            userPassword: 'Password for the user (English only)',
            userIdentifier: 'Identifier for the user (English only)',
            createCompany: 'Create Company',
            userNameNoteNoPrefix: '*You must enter a user prefix before you can enter a username',
            userNameNote: (key, {companyUsersPrefix, userIdentifier}) => {
                return '*The actual username that will be created is: ' + companyUsersPrefix + "-" + (userIdentifier || '"User Identifier"')
            },
            userPrefixError: 'The user prefix must be in English only',
            userFirstName: 'First Name',
            userLastName: 'Last Name',
            contactFirstName: 'Contact First Name',
            contactLastName: 'Contact Last Name',
            countryCode: 'Country',
        },
        editCourse: {
            courseName: 'Course Name',
            docName: 'Course Name',
            courseDescription: 'Course Description',
            description: 'Course Description',
            companyName: 'Company Name',
            dropZipHere: 'Drag the course zip file here or click to select a file',
            dropZipNote: '**Note that you are in edit mode, so if a zip file already exists for this course, uploading another file will overwrite the existing one**',
            saveChanges: 'Save Changes',
            modalTitle: 'Edit Course',
        },
        editCustomer: {
            modalTitle: 'Edit Customer',
            adminUserDetails: 'Primary User Details',
            detailsTitle: 'Edit Company Details',
            organizationsTitle: `Customer's Organizational Units`,
            addOrganizations: 'Add Organizational Units to Customer',
            addOrganizationModal: {
                organizationsList: 'List of Organizational Units',
                useCommaSeparatedValues: 'Enter comma-separated values, for example: "Finance, Accounting, Software Development"',
                title: 'Add Organizational Units to Customer',
            },
            mfaForAllUsers: 'Require MFA for all company users',
        },
        coursesTable: {
            columns: {
                courseName: 'Task Name',
                description: 'Task Description',
                edit: 'Edit',
                type: 'Task Type',
                editCourse: 'Edit Course',
                companyName: 'Company Name',
                remove: 'Delete',
                uploadStatus: 'Upload Status',
            },
            uploadStatus: {
                READY: 'Ready',
                UPLOADING: 'Uploading...',
                FAILED: 'Failed',
            }
        },
        customersTable: {
            downloadReport: 'Download Companies Report',
            downloadingReport: 'Downloading Report...',
            reportGenerated: 'Report Generated Successfully',
            reportError: 'Error Generating Report',
            columns: {
                companyName: 'Company Name',
                taxIdentifier: 'Identifier',
                edit: 'Edit',
                editCompany: 'Edit Company',
                smsQuota: 'Messages Credit',
                userQuota: 'Users Quota',
                activeUsers: 'Active Users',
                featureFlags: 'Features',
                storageQuotaMB: 'Storage (MB)',
                editQuota: 'Edit Quotas',
                welcomeMessage: 'Send Welcome Message',
                welcomeMessageSent: 'Message Sent',
                loginAs: 'Login As',
                delete: 'Delete',
            },
            deleteCompany: {
                button: 'Delete',
                title: 'Permanently Delete Company',
                warning: 'This permanently deletes the company and ALL its data. This cannot be undone.',
                backupNote: "The company's learning records (UserSignDoc data) are backed up to S3 before deletion.",
                confirmLabel: 'Type the company name or identifier to confirm:',
                confirmPlaceholder: 'Company name or identifier',
                cancel: 'Cancel',
                confirm: 'Delete Company',
                deleting: 'Deleting...',
                success: 'Company deleted successfully',
                error: 'Failed to delete company. Please try again.'
            },
            welcomeMessage: {
                confirmTitle: 'Send Welcome Message to',
                confirmMessage: 'Are you sure you want to send welcome messages to all users in this company?',
                detailsTitle: 'Welcome Message Details',
                sentDate: 'Sent Date:',
                sentBy: 'Sent By:',
                company: 'Company:'
            },
            quota: {
                editQuota: 'Edit Quotas',
                editQuotaTitle: 'Edit Quotas for Company',
                editCredits: 'Edit Credits',
                editUserQuota: 'Users Quota',
                MessagesCreditsToEdit: 'Messages Credits',
                storageQuotaToEdit: 'Storage in MB',
            }
        },
        createNewPartner: {
            modalTitle: 'Create New Partner',
            identifier: 'Identifier',
            partnerName: 'Partner Name',
            contactEmail: 'Contact Email',
            contactPhone: 'Contact Phone',
            contactFirstName: 'Contact First Name',
            contactLastName: 'Contact Last Name',
            createPartner: 'Create Partner',
            detailsTitle: 'Fill in partner details',
            clientId: 'Client ID',
            clientSecret: 'Client Secret',
        }
    },
    dataGrid: {
        filters: {
            search: {
                input: 'Search',
            },
        },
        filterLabels: {
            course: 'Course',
            organization: 'Organizational Unit',
            company: 'Company',
            signDoc: 'Tasks',
            fileType: 'File Type'
        },
        footer: {
            rowsSelected: (key, {count}) => count === 1 ? '1 row selected' : `${count} rows selected`
        }
    },
    importUsersPage: {
        downloadExample: 'Download a Template File to Create Users',
        downloadUsersAsCSV: 'Download Users as CSV File',
    },
    importUsersModal: {
        title: 'Import / Edit Users & Units',
        tabs: {
            importUsers: {
                title: 'Import Users and Add Units',
            },
            reorganizeUsers: {
                title: 'Import Users and Change Units',
            }
        },
        manyUsersMessage: 'It seems there are many users in the file, importing may take several minutes. After clicking Create, please keep the window open until the upload is complete, and then wait a few more minutes for all changes to be reflected in the system.',
        users: {
            firstName: 'First Name',
            lastName: 'Last Name',
            phone: 'Phone',
            email: 'Email',
            idNumber: 'ID Number',
            employeeId: 'Employee ID',
            organizations: 'Organizational Units',
            // Additional aliases for Excel header matching (used by getAllTranslationsForSubKeys)
            organizationsAliases: ['Organizations', 'Organization', 'Units', 'Unit', 'Org', 'Orgs'],
        },
        createUsers: 'Create/Edit Users',
        selectOrganization: 'Select organizational units for which the users will be created',
        selectOrganizationsToAdd: 'Select organizational units to add',
        organization: 'Organizational Unit',
        newUsersWillBeCreatedAndOrganizationsWillBeAddedToAllUsers: 'The organizational units will be added to all users found in the attached file. Users who do not exist will be created, existing users will be updated.',
        newUsersWillBeCreatedAndOrganizationsWillBeOverride: 'The organizational units will be changed for all users in the attached file (users will be removed from units that are not selected). Users who do not exist will be created, existing users will be updated.',
        errors: {
            missingMandatoryField: (key, {row}) => `*Missing mandatory fields in row ${row}:`,
            twoSourcesForOrgs: 'You cannot select organizational units from both sources. Please remove the organizational units from the imported file or from the selection at the top of the page',
            removeOrgsFromFile: 'Please remove the organizational units from the imported file',
            missingSourceForOrgs: 'No organizational units selected for users. Please choose units from the top of the page or add them in the import template file.',
            missingSourceForOrgsSelectFromMultiSelect: 'No organizational units selected for users. Please choose units from the selection at the top of the page.',
            noFirstNameColumn: 'The file must include a column named "First Name"',
            noLastNameColumn: 'The file must include a column named "Last Name"',
            emptyExcelFile: 'The Excel file is empty or does not contain a worksheet',
            invalidExcelFile: 'The Excel file is corrupted or invalid, please check the file and try again',
            unsupportedFileType: 'File type is not supported. Please upload a CSV or Excel (.xlsx, .xls) file',
            missingColumn: (key, {columnName}) => `The file must include a column named "${columnName}"`,
        }
    },
    uploadBox: {
        uploading: 'Uploading file...',
        uploaded: 'File uploaded successfully',
        uploadFailed: 'The file is invalid. Please check that the file size and file type do not exceed the allowed limit.',
        maxFileSize: (key, {maxFileSize}) => `The maximum allowed file size is ${maxFileSize}`,
        onlyFileTypes: (key, {fileTypes}) => `Allowed file types for upload are: ${map(fileTypes, fileType => `${fileType}`).join(', ')}`,
    },
    completedCoursePage: {
        title: 'Course Completion',
        subTitle: 'Please confirm that you have finished the course',
        buttons: {
            confirmCourseCompletion: 'I confirm I have finished the course'
        },
        finishedSuccessfully: 'You have successfully completed the course',
        oops: 'Oops...',
        youGotLost: 'It seems you got lost, navigate using the menu',
        courseCompletedSuccessfullyPopup: 'You have successfully completed the course',
    },
    errors: {
        clientError: 'Error in the details provided',
        serverError: 'Server request error',
        generalServerError: 'General server request error, try reloading the page. If the problem persists, contact technical support.',
        notFound: 'Resource not found',
        forbidden: 'You do not have permission to access this resource',
        privateRouteUserNotLoggedIn: 'The user is not logged in, so the content cannot be viewed. Please log in and then try again.',
        session_expired: 'Your session has expired. Please log in again to continue.',
        too_many_requests: 'Error, you have tried too many times, please try again later',
        noAdminUserFound: 'No admin user found for this company',
        popupBlocked: 'Popup blocked. Please allow popups for this site.',
        failedToGenerateLoginUrl: 'Failed to generate login URL',
        userNotFound: 'User not found',
    },
    alertDialog: {
        ok: 'OK',
        cancel: 'Cancel',
    },
    orphanedUsers: {
        filterLabel: 'No organization',
        alertMessage: 'active users are not assigned to any organization. To fix: select "No organization" in the organization filter, then click Edit on each user and assign an organization.',
    },
    createEditUserModal: {
        editPhone: 'Edit phone',
        organizationsLabel: 'Organizational units',
        selectAllOrganizations: 'Select all organizational units',
        identifier: 'Identifier',
        createUser: 'Create User',
        saveFailed: 'Saving failed. Please try again.',
        titleCreate: 'Create/Update User',
        titleEdit: 'Edit User',
        selectOrganization: 'Select Organizational Unit',
        firstName: 'First Name',
        lastName: 'Last Name',
        idNumber: 'ID Number',
        employeeId: 'Employee ID',
        phone: 'Phone',
        email: 'Email',
        editUser: 'Edit User',
        deleteUserTitle: 'Delete User',
        sendWelcomeMessageConfirm: 'Send Message',
        deleteUserText: 'Are you sure you want to delete the user',
        deleteOrgConfirm: 'Delete User',
        deleteUserButton: 'Delete User',
        userIsCompanyAdmin: 'Company Admin',
        userIsOrgAdmin: 'Organizational Unit Admin',
        userIsOrgAdminTooltip: 'To delete this user, they must first be removed from management roles in all organizational units',
        mfaRequired: 'Two-Factor Authentication Required',
        sendWelcomeMessage: 'Send initial login message to users',
        save: 'Save/Update User',
        userWillBeEditedIfPhoneExists: 'If the phone number is already linked to a user in the company, that user and the organizational units they belong to will be updated',
    },
    phoneEditModal: {
        title: 'Edit Phone Number',
        phoneLabel: 'Phone Number',
        phonePlaceholder: 'Enter phone number',
        cancel: 'Cancel',
        save: 'Save',
        errors: {
            phone_already_exists: 'This phone number already exists in the system',
            phone_belongs_to_inactive_user: 'This phone number belongs to an inactive user',
            invalid_phone_format: 'Invalid phone number format',
            no_permission: 'No permission to update phone number',
            network_error: 'Network error, please try again',
            check_failed: 'Availability check failed, please try again',
        },
    },
    recurringAtEditModal: {
        title: 'Edit Next Version Date',
        dateLabel: 'Next version date',
        disclaimer: 'Changing the next version date will be enforced for all users assigned to this task.',
        cancel: 'Cancel',
        save: 'Save',
        errors: {
            saveFailed: 'Failed to update date, please try again',
        },
    },
    allUsersTable: {
        columns: {
            fullName: 'Full Name',
            email: 'Email',
            phone: 'Phone',
            roles: 'Roles',
            identifier: 'Identifier',
            idNumber: 'ID Number',
            employeeId: 'Employee ID',
            organization: 'Organizational Unit',
            id: 'ID',
            edit: 'Edit',
            delete: 'Delete',
            restore: 'Restore User',
            deleted: 'Deleted',
            sendWelcomeMessage: 'Send Welcome Message',
            loginAs: 'Login As',
        },
            buttons: {
                deleteUsers: 'Delete Users',
            },
            filters: {
            allUsers: 'All Users',
            activeOnly: 'Active Users Only',
            deletedOnly: 'Deleted Users Only',
        }
    },
    removeCourseFromCompanyCol: {
        deleteCourseButton: 'Delete Course',
        removeCourseTitle: 'Delete Course',
        removeCourseText: 'Are you sure you want to delete the course',
        removeCourseConfirm: 'Delete Course',
    },
    CourseReminderNotificationButton: {
        alerts: {
            reminderSent: 'Reminders are on their way!',
            reminderNotSent: 'Error sending reminder',
            sentMessages: 'Messages sent',
            notSentMessages: 'Messages not sent',
            notSentMessagesInfo: '* There can be two reasons why not all messages were sent: lack of contact information or an incorrect phone number',
            sendToUsersWhoDidNotReceiveNotification: 'Send a reminder to users who have not yet received one',
            sendToAllUsers: 'Send a reminder to all course users who have not yet completed',
            error: 'Error',
            company_has_no_sms_quota: 'The company does not have enough message credits available, please contact customer service to purchase a messages package',
            user_already_received_welcome_message: 'The user has already received a welcome message',
            general_error: 'An error occurred while sending the notification, please try again later'
        }
    },
    FilesManagementPage: {
        title: 'Files Management',
        subTitle: 'View, add, and edit',
        fileManagementTable: {
            columns: {
                fileName: 'Download Link',
                presentationName: 'Display Name',
                isReady: 'Ready for Download',
                companyName: 'Company',
                organizationNames: 'Organizational Units',
                date: 'Creation Date',
                createdByUser: 'Created By',
            },
            download: 'Download',
            inProgress: 'Creation in progress',
            ready: 'Ready for download',
            allOrganizations: 'All organizational units',
        }
    },
    SMSNotificationButton: {
        title: 'Send Reminder',
        subTitle: 'Immediately'
    },
    sendSMSModal: {
        title: 'Who are we reminding?',
        sms: 'SMS',
        whatsapp: 'WhatsApp',
        email: 'Email',
        selectMessageDeliveryWay: 'Messages will be sent via:',
        sendToOptions: {
            all: 'Users who have not completed a specific task',
            onlyNotNotified: 'All who have not completed the course and have not received a reminder',
            allWithAnyOpenTasks: 'Users with open tasks',
            knowledgeCenter: 'Knowledge Center',
            pleaseSelect: 'Please select the group you want to send to',
            label: 'Who?'
        },
        taskOptions: {
            label: 'Which task?',
            pleaseSelect: 'Please select the course for which you want to send a reminder',
        },
        organizationOptions: {
            label: 'Which organizational unit?',
            pleaseSelect: 'Please select the organizational unit for which you want to send a reminder',
        },
        smsStatusInformation: {
            statusTitle: 'Great!',
            statusUserToNotify: `So in total, we're reminding `,
            bySMS: 'via SMS',
            byWhatsApp: 'via WhatsApp',
            byEmail: 'via Email',
            statusCompanyQuota: 'For your information, after sending, you will have ',
            SMSForUse: 'messages left to use',
            employees: 'employees',
            theyWillReceiveItAsFollowing: 'who will receive the messages through the following methods',
            existing: 'existing',
            usersDontHaveEmails: 'users without email addresses'
        },
        error: {
            noUsersToSendOnlyNotNotified: 'There are no users to send to; all users who have not completed the course have already received a reminder',
            notEnoughSMS: 'You do not have enough message credits available, please contact customer service to purchase a messages package',
            noUsersInCourse: 'No users to send to; all users in this course have completed it',
            youAreLeftWithQuota: 'You still have',
            youNeed: 'and you need a total of',
            toCompleteTheProcess: 'to complete the process',
        },
        send: 'Send'
    },
    SADeleteUsersModal: {
        title: 'Delete Users',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        employeeID: 'Employee ID',
        idNumber: 'ID Number',
        organizations: 'Organizations',
        identifier: 'Identifier',
        message: (key, {userCount}) => `Are you sure you want to delete the following ${userCount} users?`,
        deleteUsers: 'Delete Users',
        fetchError: 'Error loading user data',
        deleteError: 'Error deleting users',
        deleting: 'Deleting...',

        // Confirmation view
        confirmMessage: (key, {userCount}) => `Are you sure you want to delete ${userCount} users?`,
        confirmHint: 'Users who are organizational admins will not be deleted and will be shown in the results report.',

        // Results view
        resultsTitle: 'Deletion Results',
        successTitle: 'Deletion Completed Successfully',
        noDeletedTitle: 'No Users Deleted',

        deletedUsersTitle: 'Deleted Users',
        skippedUsersTitle: 'Skipped Users',

        // Result messages
        successMessageOnly: (key, {deleted}) => `Successfully deleted ${deleted} user(s).`,
        noDeletedMessage: (key) => `No users were deleted.`,

        skippedExplanationTitle: 'Why were users not deleted?',
        skippedExplanation: 'The following users were not deleted because they are organizational admins or have other restrictions. To delete them, first remove their admin permissions from all relevant organizations.',

        skipReason: 'Reason',
        reasons: {
            orgAdmin: 'Organizational Admin',
            adminOf: 'Admin of',
            self: 'Cannot delete yourself',
            notFound: 'User not found',
            // Deletion protection reasons from backend
            cannot_delete_self: 'Cannot delete yourself',
            cannot_delete_superadmin: 'Cannot delete SuperAdmin',
            cannot_delete_company_admin: 'Cannot delete Company Admin',
            cannot_delete_organizational_admin: 'Cannot delete Organizational Admin',
            different_company: 'User belongs to different company',
            not_an_organizational_admin: 'Not an organizational admin',
            not_admin_of_all_user_organizations: 'Not admin of all user organizations',
            generic_error: 'User cannot be deleted'
        }
    },
    SARemoveUser: {
        permanentlyDeleteUser: 'Permanent Deletion',
        deleteUserTitle: 'Permanently Delete User',
        deleteUserText: 'Are you sure you want to permanently delete the user',
        deleteOrgConfirm: 'Permanently Delete User',
    },
    SADeleteUsersPermanentlyModal: {
        title: 'Permanently Delete Users',
        firstName: 'First Name',
        lastName: 'Last Name',
        email: 'Email',
        phone: 'Phone',
        employeeID: 'Employee ID',
        idNumber: 'ID Number',
        organizations: 'Organizations',
        identifier: 'Identifier',
        warningTitle: 'Warning! Irreversible Action',
        warningMessage: (key, {userCount}) => `You are about to permanently delete ${userCount} users. This action cannot be undone and will permanently remove the users from the database.`,
        confirmationRequired: 'To confirm, type the following text:',
        confirmationText: 'delete permanently',
        confirmationPlaceholder: 'Type "delete permanently" to confirm',
        deleteUsersPermanently: 'Delete Users Permanently',
        cancel: 'Cancel',
        fetchError: 'Error fetching user data',
        deleteError: 'Error permanently deleting users',
        deleting: 'Deleting permanently...',
        confirmationMismatch: 'The text entered does not match. Please type "delete permanently" exactly.',
    },
    SARestoreUser: {
        restoreUsers: 'Restore Users',
        restoreUsersTitle: 'Restore Users',
        restoreUsersText: (key, {userCount}) => `Are you sure you want to restore ${userCount} users?`,
        restoreUsersConfirm: 'Yes, Restore Users',
    },
    automations: {
        title: 'Automations',
        subTitle: 'Management and Settings',
        addAutomation: 'Add Automation',
        editAutomation: 'Edit Automation',
        deleteAutomation: 'Delete Automation',
        automationName: 'Automation Name',
        automationDescription: 'Automation Description',
        automationImage: 'Automation Image',
        automationCard: {
            editAutomation: 'Edit Automation',
        },
        notifications: {
            title: 'Create Automation',
            subTitle: 'To schedule reminders',
        },
        createAutomationModal: {
            title: 'Create New Automation',
            weWillSendNotificationTo: 'We will remind everyone who has not completed the course ',
            allOrganizations: 'All organizational units',
            allCourses: 'All tasks',
            automationKind: {
                signDoc: 'Task Reminders',
                course: 'Course Reminders',
                signDocDescription: 'Reminders for documents to sign, videos, audio and other tasks',
                courseDescription: 'Reminders for regular courses and learning materials'
            },
            organizationOptions: {
                label: 'Which organizational unit?',
                pleaseSelect: 'Please select the organizational unit you want to send a reminder for',
                error: 'You must select an organizational unit for sending the reminder'
            },
            taskOptions: {
                label: 'Which task?',
                signDocLabel: 'Which task?',
                courseLabel: 'Which course?',
                pleaseSelect: 'Please select the task for which you want to send a reminder',
                error: 'You must select a course for sending the reminder'
            },
            selectHourLabel: 'At what time?',
            selectHourError: 'You must select a time to send the reminder',
            howManyDaysBefore: 'How many days before?',
            howManyDaysBeforeError: 'You must select how many days before you want to send the reminder',
            daysBeforeError: 'You must select a valid number of days between 1 and 50',
            nameLabel: 'Automation Name',
            nameError: 'You must enter a name for the automation',
            descriptionLabel: 'Automation Description',
            create: 'Create Automation',
            automationType: {
                label: 'Automation Type',
                oneTime: 'One-time Reminder',
                recurring: 'Recurring Reminders'
            },
            recurring: {
                frequency: 'Frequency',
                every: 'Every',
                startDate: 'Start Date',
                endDate: 'End Date (Optional)',
                maxRuns: 'Number of Runs',
                unlimited: 'Unlimited',
                runHour: 'Run Hour',
                preview: 'Preview',
                startDateRequired: 'You must enter a start date',
                startDatePast: 'Start date cannot be in the past',
                endDateInvalid: 'End date must be after start date',
                maxRunsRequired: 'You must enter a maximum number of runs',
                runHourRequired: 'You must select a run hour',
                daily: 'Daily',
                weekly: 'Weekly',
                monthly: 'Monthly',
                dailySingle: 'day',
                dailyPlural: 'days',
                weeklySingle: 'week',
                weeklyPlural: 'weeks',
                monthlySingle: 'month',
                monthlyPlural: 'months',
            },
            modalRecurringPreview: (key, {frequencyText, runHour, runTimes}) => `Reminders will be sent every ${frequencyText} at ${runHour}, total of ${runTimes} runs`
        }
    },
    automationsTable: {
        columns: {
            automationName: 'Automation Name',
            automationType: 'Automation Type',
            description: 'Automation Description',
            organization: 'Organizational Units',
            task: 'Tasks',
            when: 'When?',
            progress: 'Progress',
            status: 'Status',
            how: 'How is it sent?',
            delete: 'Delete',
            edit: 'Edit',
            details: 'Details',
        },

        status: {
            SCHEDULED: 'Scheduled',
            COMPLETED: 'Completed',
            PAUSED: 'Paused',
            CANCELLED: 'Cancelled',
            sentAndNotSent: (key, {sent, notSent}) => `Sent ${sent} and not sent ${notSent}`,
        },
        sendType: {
            SMS: 'Text Message',
            EMAIL: 'Email',
            WHATSAPP: 'WhatsApp',
        },
        atHour: 'at',
        daysBefore: 'days before the course end date',
        automationRuns: {
            title: 'Execution History',
            columns: {
                runNumber: 'Run #',
                scheduledTime: 'Scheduled Time',
                actualTime: 'Actual Execution Time',
                status: 'Status',
                usersProcessed: 'Users Checked',
                messagesSent: 'Messages Sent',
                messagesFailed: 'Messages Failed',
                successRate: 'Success Rate',
                details: 'Details'
            },
            runStatuses: {
                SCHEDULED: 'Scheduled',
                RUNNING: 'Running Now',
                COMPLETED: 'Completed',
                FAILED: 'Failed',
                SKIPPED: 'Skipped'
            }
        },
        nextRun: 'Next Run',
        lastRun: 'Last Run',
        totalRuns: 'Total Runs',
        automationTypeBadge: {
            oneTime: 'Before finish',
            recurring: 'Recurring'
        }
    },
    allOrganizations: 'All organizational units',
    allSignDocs: 'All tasks',
    organizationIntersectionFilter: {
        label: 'Organization Intersection',
        tooltip: 'Filter users who belong to ANY organization from the left group AND ANY organization from the right group. Example: if left group has Org1,Org2 and right group has Org3,Org4, results will show users who are in (Org1 OR Org2) AND (Org3 OR Org4).'
    },
    confirmationModal: {
        confirm: 'Confirm',
        cancel: 'Cancel',
    },
    deleteAutomationModal: {
        title: 'Delete Automation',
        message: 'Are you sure you want to delete the automation?',
        deleteAutomation: 'Delete Automation',
        automationName: 'Automation Name',
    },
    newDocSign: {
        buttonTitle: 'Create a New Task',
        modal: {
            title: 'Create a New Document',
            newVersionTitle: 'Create New Version',
            editSignDocTitle: 'Edit Document',
            docNameLabel: {
                'REGULAR_COURSE': 'Document Name',
                'READ_AND_SIGN_DOC_PDF': 'Document Name',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Video Name',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Video Name',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Video Name',
                'CANVA_PRESENTATION': 'Presentation Name',
                'EXAM': 'Exam Name',
                'LEARNING_PATH': 'Learning Path Name',
                'PODCAST': 'Podcast Name',
                'AUDIO_FILE': 'Audio File Name',
                'FRONTAL_COURSE': 'Frontal Lecture Name',
                'ONLINE_COURSE': 'Online Course Name',
                'PRESENTATION': 'Presentation Name',
                'ARTICLE': 'Article Name',
                'SURVEY': 'Survey Name',
                'LINK': 'Link Name',
                'UPLOAD_DOCUMENT': 'Task Name',
            },
            docDescriptionLabel: {
                'REGULAR_COURSE': 'Document Description',
                'READ_AND_SIGN_DOC_PDF': 'Document Description',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Video Description',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Video Description',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Video Description',
                'CANVA_PRESENTATION': 'Presentation Description',
                'EXAM': 'Exam Description',
                'LEARNING_PATH': 'Learning Path Description',
                'PODCAST': 'Podcast Description',
                'AUDIO_FILE': 'Audio File Description',
                'FRONTAL_COURSE': 'Frontal Lecture Description',
                'ONLINE_COURSE': 'Online Course Description',
                'PRESENTATION': 'Presentation Description',
                'ARTICLE': 'Article Description',
                'SURVEY': 'Survey Description',
                'LINK': 'Link Description',
                'UPLOAD_DOCUMENT': 'Task Description',
            },
            createButtonText: {
                'REGULAR_COURSE': 'Create Course',
                'READ_AND_SIGN_DOC_PDF': 'Create Document',
                'WATCH_AND_SIGN_YOUTUBE_LINK': 'Create Viewing Task',
                'WATCH_AND_SIGN_VIMEO_LINK': 'Create Viewing Task',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Create Viewing Task',
                'AUDIO_FILE': 'Create Listening Task',
                'CANVA_PRESENTATION': 'Create Presentation',
                'EXAM': 'Create Exam',
                'LEARNING_PATH': 'Create Learning Path',
                'PODCAST': 'Create Podcast',
                'FRONTAL_COURSE': 'Create Frontal Lecture',
                'ONLINE_COURSE': 'Create Online Course',
                'PRESENTATION': 'Create Presentation',
                'ARTICLE': 'Create Article',
                'SURVEY': 'Create Survey',
                'LINK': 'Create Link',
                'UPLOAD_DOCUMENT': 'Create Upload Task',
            },
            dropDocLabel: {
                'READ_AND_SIGN_DOC_PDF': 'Drag PDF file here or click to select file',
                'WATCH_AND_SIGN_VIDEO_FILE': 'Drag video file here or click to select file',
                'AUDIO_FILE': 'Drag audio file here or click to select file',
                'UPLOAD_DOCUMENT': 'Drag file here or click to select file (PDF, DOC, DOCX, XLS, XLSX, TXT, JPG, PNG)',
            },
            examExtraSaveButton: 'Save and continue to edit questions',
            weezBeeCourseExtraSaveButton: 'Save and continue to edit course',
            learningPathExtraSaveButton: 'Save and continue to edit learning path',
            surveyExtraSaveButton: 'Save and continue to edit survey',
            createDocument: 'Create Document',
            createExam: 'Create Exam',
            createLearningPath: 'Create Learning Path',
            dropSignDocHere: 'Drag document file here or click to select file',
            selectSignDocType: 'Type',
            linkUrl: 'Link',
            youtubeLinkNotAllowed: 'You cannot enter a Youtube link',
            vimeoLinkNotAllowed: 'You cannot enter a Vimeo link',
            canvaLinkNotAllowed: 'You cannot enter a Canva link',
            invalidLink: "Invalid link",
            notifyUsersOfNewTask: 'Send a message to users about a new task',
            notifyUsersOfNewTaskTooltip: 'The message will only be sent to users who have not yet received a notification about this task',
            quotaWarning: {
                title: 'Insufficient Message Credits',
                message: (key, { quotaNeeded, quotaAvailable, totalUsers }) => `You need ${quotaNeeded} message credits to notify ${totalUsers} users, but only ${quotaAvailable} credits are available.`,
                contactSupport: 'Please contact support to purchase additional message credits, or turn off the notification toggle to save without sending notifications.',
                disableNotificationToSave: 'Turn off notifications to save the document',
            },
            forceCompletion: 'Required to complete',
            nonForceCompletion: 'Knowledge Center',
            noDate: 'No end date',
            isMustDo: {
                label: 'Mandatory for compliance',
                tooltip: 'Users must complete this task to pass the external compliance check'
            },
            allowFastForward: {
                WATCH_AND_SIGN_VIDEO_FILE: 'Allow fast forward in video',
                WATCH_AND_SIGN_YOUTUBE_LINK: 'Allow fast forward in video',
                WATCH_AND_SIGN_VIMEO_LINK: 'Allow fast forward in video',
                AUDIO_FILE: 'Allow fast forward in audio file',
            },
            organizationAssignmentInfo: 'You will be able to assign the task to organizational units when editing the task',
            assignToAllOrganizations: 'Assign to all organizational units',
            removeFromAllOrganizations: 'Remove from all organizational units',
            assignmentTabs: {
                organizations: 'Assign to Organizational Units',
                individualUsers: 'Assign to Individual Users'
            },
            assignmentSubTabs: {
                allUsers: 'All Users',
                selected: 'Selected',
                noSelectedUsers: 'No users selected'
            },
            recurring: {
                toggleLabel: 'Enable Periodic',
                toggleDescription: 'Automatically create new versions at regular intervals',
                frequencyLabel: 'Periodicity',
                frequencyNote: 'Users will be reassigned to new versions based on this schedule',
                nextVersionDate: 'Next version will be created on',
                minimumFrequencyError: 'Minimum periodicity is 1 month',
                nextVersionDateLabel: 'Next version date',
                transitionDisclaimer: 'This task is changing from a regular task to a recurring one. You must select a date for the next version. This date will be enforced for all assigned users. After this date, new versions will be created automatically based on the selected frequency. You can edit this date at any time from the version management page.',
            },
            groupType: {
                label: 'Frequency',
                SEQUENTIAL: 'Periodic',
                PARALLEL: 'No Frequency'
            },
            status: {
                label: 'Status',
                ACTIVE: 'Active',
                ARCHIVED: 'Archived'
            }
        },
    },
    signDocModal: {
        importUsers: {
            modalTitle: 'Import Users from File',
            importFromFile: 'Import from file',
            matchedUsers: 'Matched Users',
            unmatchedRows: 'Unmatched Rows',
            addUsers: (key, {count}) => `Add ${count} Users`,
            noMatchesFound: 'No matching users found',
            unmatchedRowsHint: "These rows didn't match any users in the system. Verify phone numbers are correct.",
            processingFile: 'Processing file...',
            fileError: 'Error reading file'
        }
    },
    signDocProgress: {
        notStarted: {
            READ_AND_SIGN_DOC_PDF: 'Not read',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Unwatched',
            WATCH_AND_SIGN_VIMEO_LINK: 'Unwatched',
            WATCH_AND_SIGN_VIDEO_FILE: 'Unwatched',
            AUDIO_FILE: 'Not listened',
            REGULAR_COURSE: 'Not started',
            CANVA_PRESENTATION: 'Unwatched',
            EXAM: 'Not started',
            LEARNING_PATH: 'Not started',
            LINK: 'Not visited',
            SURVEY: 'Not started',
            WEEZBEE_COURSE: 'Not started',
            UPLOAD_DOCUMENT: 'Not uploaded',
            FRONTAL_COURSE: 'Not attended',
            ONLINE_COURSE: 'Not started',
        },
        inProgress: {
            READ_AND_SIGN_DOC_PDF: 'Read',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Started',
            WATCH_AND_SIGN_VIMEO_LINK: 'Started',
            WATCH_AND_SIGN_VIDEO_FILE: 'Started',
            AUDIO_FILE: 'Listened',
            REGULAR_COURSE: 'Started',
            CANVA_PRESENTATION: 'Watched',
            EXAM: 'Started',
            LEARNING_PATH: 'Started',
            LINK: 'Visited',
            SURVEY: 'Started',
            WEEZBEE_COURSE: 'Started',
            UPLOAD_DOCUMENT: 'Uploaded',
            FRONTAL_COURSE: 'Registered',
            ONLINE_COURSE: 'Registered',
        },
        finished: {
            READ_AND_SIGN_DOC_PDF: 'Signed!',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Completed!',
            WATCH_AND_SIGN_VIMEO_LINK: 'Completed!',
            WATCH_AND_SIGN_VIDEO_FILE: 'Completed!',
            AUDIO_FILE: 'Completed!',
            REGULAR_COURSE: 'Completed!',
            CANVA_PRESENTATION: 'Signed!',
            EXAM: 'Completed!',
            LEARNING_PATH: 'Completed!',
            LINK: 'Read!',
            SURVEY: 'Completed!',
            WEEZBEE_COURSE: 'Completed!',
            UPLOAD_DOCUMENT: 'Approved',
            FRONTAL_COURSE: 'Completed!',
            ONLINE_COURSE: 'Completed!',
        },
        completedOn: 'Signature Date: ',
        completedOnCourse: 'Completion Date: ',
        by: 'by ',
        manual: 'Manual',
        finishBy: 'To be completed by: ',
        score: 'Score',
    },
    signDocProgressMgmnt: {
        notStarted: 'Not Opened',
        inProgress: 'Opened',
        finished: 'Signed',
        opened: 'Opened'
    },
    signDocPage: {
        title: {
            read: {
                sign: 'Document Reading Approval',
                noSign: 'Document Reading',
                knowledgeOnly: 'Document Reading'
            },
            watch: {
                sign: 'Video Viewing Approval',
                noSign: 'Video Viewing',
                knowledgeOnly: 'Video Viewing'
            },
            listen: {
                sign: 'Audio Listening Approval',
                noSign: 'Audio Listening',
                knowledgeOnly: 'Audio Listening'
            },
            link: {
                sign: 'Link Visit Approval'
            },
            upload: {
                sign: 'Document Upload',
                noSign: 'View Uploaded Document',
                knowledgeOnly: 'Document Upload'
            },
            canva: {
                sign: 'Presentation Viewing Approval',
                noSign: 'Presentation Viewing',
                knowledgeOnly: 'Presentation Viewing'
            }
        },
        subTitle: {
            read: {
                sign: 'Approve and sign that you have read the document',
                noSign: 'Re-reading after signing',
            },
            watch: {
                sign: 'Approve and sign that you have watched the video',
                noSign: 'Re-watching after signing',
            },
            listen: {
                sign: 'Approve and sign that you have listened to the audio',
                noSign: 'Re-listening after signing',
            },
            link: {
                sign: 'Approve and sign that you have visited the link'
            },
            upload: {
                sign: 'Please upload the required document',
                noSign: 'Document uploaded successfully'
            },
            canva: {
                sign: 'Go through the entire presentation and sign to confirm',
                noSign: 'Re-viewing after signing'
            }
        },
        signatureTitle: {
            read: 'Sign to confirm that you have read the document',
            watch: 'Sign to confirm that you have watched the video',
            listen: 'Sign to confirm that you have listened to the audio',
            link: 'Sign to confirm that you have visited the link',
            canva: 'Sign to confirm you have completed the entire presentation',
        },
        signatureSubtitle: {
            read: 'In order to confirm reading the document, sign here',
            watch: 'In order to confirm watching the video, sign here',
            listen: 'In order to confirm listening to the audio, sign here',
            link: 'In order to confirm visiting the link, sign here',
            canva: 'In order to confirm completing the presentation, sign here',
        },
        signatureSubtitleNotCompleted: {
            read: 'After reading, a signature pad and confirmation button will appear',
            watch: 'After watching, a signature pad and confirmation button will appear',
            listen: 'After listening, a signature pad and confirmation button will appear',
            canva: 'After completing the presentation, a signature pad and confirmation button will appear',
        },
        iApproveReadingTheDoc: {
            read: 'I have read the document!',
            watch: 'I have watched the video!',
            listen: 'I have listened to the audio!',
            link: 'I have visited the link!',
            canva: 'I have completed the presentation!',
        },
        clear: 'Clear Signature',
        uploadDocument: {
            title: 'Upload Document',
            subtitle: 'Please upload the required document',
            completed: 'Document Approved Successfully',
            completedMessage: 'Thank you! Your document has been successfully approved by the administrator.',
            uploaded: 'Document Uploaded Successfully',
            waitingApproval: 'Document is waiting for admin approval',
            uploadedFile: 'Uploaded Document',
            fileSize: 'File Size',
            stepUploaded: 'Uploaded',
            replaceFile: 'Drag a new file or click to replace',
            uploadedFiles: 'Uploaded Files',
            saveButton: 'Save and Return Home',
            rejectionTitle: 'Your Document Was Rejected',
            rejectionReasonLabel: 'Rejection Reason',
            rejectedBy: 'Rejected by',
            rejectionNoReason: 'The administrator rejected the document without providing a reason.',
            rejectionAction: 'Please upload a new document according to the guidelines.',
            successModal: {
                title: 'Document Saved Successfully!',
                message: 'Your document has been uploaded successfully and is waiting for admin approval.',
                autoRedirect: 'Redirecting you to home page...'
            },
            enableApprovals: {
                toggleLabel: 'Require approval for uploads',
                enabledNote: 'When enabled, admins must approve user-uploaded files before the task is marked as complete.',
                disabledNote: 'When disabled, user-uploaded files will be auto-approved and the task will be marked as complete immediately.'
            }
        },
        courseAttendanceApprovals: {
            sectionTitle: 'Attendance Approvers',
            description: 'Select specific users who can mark attendance for this course. If none selected, only company admins can mark attendance.',
            userLabel: 'Select users as attendance approvers',
        }
    },
    filePreview: {
        noPreviewAvailable: 'No preview available',
        notAvailable: 'Preview not available for this file type',
        downloadToView: 'Download file to view'
    },
    signDocCard: {
        rejected: 'Rejected',
        rejectedMessage: 'Your document was rejected',
        uploadAgain: 'Upload Again',
        noDateSet: 'No date set',
        youAreDone: {
            READ_AND_SIGN_DOC_PDF: 'You signed the document',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'You watched the video',
            WATCH_AND_SIGN_VIMEO_LINK: 'You watched the video',
            WATCH_AND_SIGN_VIDEO_FILE: 'You watched the video',
            AUDIO_FILE: 'You listened to the audio file',
            REGULAR_COURSE: 'You completed the course',
            CANVA_PRESENTATION: 'You watched the presentation',
            EXAM: 'You completed the exam',
            WEEZBEE_COURSE: 'You completed the course',
            LEARNING_PATH: 'You completed the training',
            LINK: 'You visited the link',
            SURVEY: 'You completed the survey',
            UPLOAD_DOCUMENT: 'You uploaded the document',
            FRONTAL_COURSE: 'You attended the lecture',
            ONLINE_COURSE: 'You completed the online course',
        },
        finishBy: {
            READ_AND_SIGN_DOC_PDF: (key, {finishByDate}) => `Must sign by ${finishByDate}`,
            WATCH_AND_SIGN_YOUTUBE_LINK: (key, {finishByDate}) => `Must watch by ${finishByDate}`,
            WATCH_AND_SIGN_VIMEO_LINK: (key, {finishByDate}) => `Must watch by ${finishByDate}`,
            WATCH_AND_SIGN_VIDEO_FILE: (key, {finishByDate}) => `Must watch by ${finishByDate}`,
            AUDIO_FILE: (key, {finishByDate}) => `Must listen by ${finishByDate}`,
            REGULAR_COURSE: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
            CANVA_PRESENTATION: (key, {finishByDate}) => `Must watch by ${finishByDate}`,
            EXAM: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
            WEEZBEE_COURSE: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
            LEARNING_PATH: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
            LINK: (key, {finishByDate}) => `Must visit by ${finishByDate}`,
            SURVEY: (key, {finishByDate}) => `Must complete by ${finishByDate}`,
            UPLOAD_DOCUMENT: (key, {finishByDate}) => `Must upload by ${finishByDate}`,
            FRONTAL_COURSE: (key, {finishByDate}) => `Lecture on: ${finishByDate}`,
            ONLINE_COURSE: (key, {finishByDate}) => `Course session: ${finishByDate}`,
        },
        youAreDoneWatchAgain: {
            READ_AND_SIGN_DOC_PDF: 'Read again',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Watch again',
            WATCH_AND_SIGN_VIMEO_LINK: 'Watch again',
            WATCH_AND_SIGN_VIDEO_FILE: 'Watch again',
            AUDIO_FILE: 'Listen again',
            REGULAR_COURSE: 'Watch again',
            CANVA_PRESENTATION: 'Watch again',
            EXAM: 'Review exam',
            LEARNING_PATH: 'Review training',
            LINK: 'Visit again',
            SURVEY: 'Review survey',
            WEEZBEE_COURSE: 'Review course',
            UPLOAD_DOCUMENT: 'View task again',
            FRONTAL_COURSE: 'View details again',
            ONLINE_COURSE: 'Watch again',
        },
        goToCourse: {
            READ_AND_SIGN_DOC_PDF: 'Go to reading',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Go to watch',
            WATCH_AND_SIGN_VIMEO_LINK: 'Go to watch',
            WATCH_AND_SIGN_VIDEO_FILE: 'Go to watch',
            AUDIO_FILE: 'Go to listen',
            REGULAR_COURSE: 'Go to course',
            CANVA_PRESENTATION: 'Go to watch',
            EXAM: 'Go to exam',
            LEARNING_PATH: 'Go to path',
            LINK: 'Go to link',
            SURVEY: 'Go to survey',
            WEEZBEE_COURSE: 'Go to course',
            UPLOAD_DOCUMENT: 'Go to upload page',
            FRONTAL_COURSE: 'Completion will be approved by administrator',
            ONLINE_COURSE: 'Go to course',
        },
        disabledButtonTooltips: {
            locked: 'The task is locked and not available now',
            surveyNotRedoable: 'The survey is anonymous and has already been completed, so it cannot be done again',
            genericNotRedoable: 'The task has already been completed and cannot be done again',
            frontalCourseDisabled: 'Attendance for frontal courses is marked by the administrator only'
        },
        examScore: (key, { score }) => `Score: ${score}`,
        completedByAdmin: 'Completed by admin',
    },
    Errors_409: {
        storage_quota_error: (key, {bytesCompanyStorageQuota, bytesCompanyUsedStorage, bytesNewUsedStorage}) => {
            const leftQuotaMB = ((bytesCompanyStorageQuota - bytesCompanyUsedStorage) / (1024 * 1024)).toFixed(2) + ' MB';
            const bytesNewUsedStorageMB = (bytesNewUsedStorage / (1024 * 1024)).toFixed(2) + ' MB';
            const bytesCompanyStorageQuotaMB = (bytesCompanyStorageQuota / (1024 * 1024)).toFixed(2) + ' MB';
            return `Not enough available storage space. Try deleting files or contact the system admin. You have ${leftQuotaMB} left out of ${bytesCompanyStorageQuotaMB} available, and the file you are trying to upload is ${bytesNewUsedStorageMB} in size`;
        },
        missing_company_organization: 'You must select an organizational unit for the user',
        user_already_received_welcome_message: 'The user has already received the welcome message',
        company_has_no_sms_quota: 'The company does not have enough available SMS credits, please contact customer support to purchase a message package',
        original_password_dont_match: 'The provided password is incorrect',
        password_too_weak: 'The password is not strong enough',
        organization_still_has_users: 'There are still users in the organization that need to be deleted or assigned to another organization',
        total_points_exceed_100: 'The sum of all question scores cannot exceed 100',
        user_not_found: 'User not found, please check if the email or phone number provided is correct. If the user is still not found, please contact the system administrator',
    },
    signDocTypes: {
        READ_AND_SIGN_DOC_PDF: 'PDF Document to Sign',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Youtube Link to Watch',
        WATCH_AND_SIGN_VIMEO_LINK: 'VIMEO Link to Watch',
        WATCH_AND_SIGN_VIDEO_FILE: 'Video File to Watch',
        REGULAR_COURSE: 'Course',
        CANVA_PRESENTATION: 'Canva Presentation to Watch',
        EXAM: 'Exam',
        WEEZBEE_COURSE: 'WeezBee Course',
        LEARNING_PATH: 'Learning Path',
        AUDIO_FILE: 'Audio File',
        LINK: 'Link to Visit',
        SURVEY: 'Survey',
        UPLOAD_DOCUMENT: 'Document to Upload',
        FRONTAL_COURSE: 'Frontal Training',
        ONLINE_COURSE: 'Online Training',
    },
    signDocTypesNotForCompletion: {
        READ_AND_SIGN_DOC_PDF: 'PDF Document',
        WATCH_AND_SIGN_YOUTUBE_LINK: 'Youtube Link',
        WATCH_AND_SIGN_VIMEO_LINK: 'VIMEO Link',
        WATCH_AND_SIGN_VIDEO_FILE: 'Video File',
        REGULAR_COURSE: 'Course',
        CANVA_PRESENTATION: 'Canva Presentation',
        EXAM: 'Exam',
        LINK: 'Link',
        WEEZBEE_COURSE: 'WeezBee Course',
        LEARNING_PATH: 'Learning Path',
        AUDIO_FILE: 'Audio File',
        SURVEY: 'Survey',
        UPLOAD_DOCUMENT: 'Upload Document',
        FRONTAL_COURSE: 'Frontal Training',
        ONLINE_COURSE: 'Online Training',
    },
    managementCourseList: {
        signDocButtonTitle: 'Create Viewing Task'
    },
    isCompanyAdmin: {
        makeAdmin: {
            title: 'Set as Company Admin',
            message: 'Are you sure you want to set the user as a company admin?',
            confirm: 'Set as Company Admin',
            button: 'Set as Company Admin',
        },
        removeAdmin: {
            title: 'Remove Company Admin',
            message: 'Are you sure you want to remove the user from the role of company admin?',
            confirm: 'Remove Company Admin',
            button: 'Remove Company Admin',
        },
        userName: 'Username',
    },
    general: {
        saveChanges: 'Save Changes',
        close: 'Close',
        cancel: 'Cancel',
        save: 'Save',
        deleteConfirm: 'Confirm deletion?',
        delete: 'Delete',
        areYouSure: 'Are you sure?',
        copyOf: 'Copy of',
        duplicating: 'Duplicating...',
        next: 'Next',
        back: 'Back',
    },
    knowledgeCenter: {
        title: 'Knowledge Center',
        subTitle: 'All information in one place',
    },
    operation: {
        title: 'Operation',
        subTitle: 'All operational information in one place',
    },
    adminUsersTable: {
        columns: {
            fullName: 'Full Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email',
            phone: 'Phone',
            roles: 'Roles',
            identifier: 'Identifier',
            managerOfOrganizations: 'Manager in Organizational Units',
            id: 'ID',
            edit: 'Edit',
            isCompanyAdmin: 'Company Admin',
            isCompanyAdminYes: 'Yes',
            isCompanyAdminNo: 'No',
        },
        addAdminUser: 'Add Admin',
    },
    editAdminUserModal: {
        title: 'Assign Admin',
        titleEdit: 'Edit Admin',
        sendWelcomeMessage: 'Send initial login message to admin',
        save: 'Save Changes',
        selectOrganizationalUnits: 'Search Organizational Units',
        searchUser: 'Search User',
        isCompanyAdmin: 'Company Admin',
        companyAdminWillBeAdminOfAllOrgs: 'A company admin will be admin of all organizational units',
        selectAllOrgs: 'Select all organizational units',
    },
    autoComplete: {
        search: 'Search',
        selectAll: 'Select All',
        noOptions: 'No results found',
    },
    UserIconMenu: {
        settings: 'Settings',
    },
    deletedUserTable: {
        emailNotAssigned: 'No email provided',
        columns: {
            fullName: 'Full Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            phoneNumber: 'Cell Phone',
            email: 'Email',
            firstLoginDate: 'Join Date',
            deletedDate: 'Deletion Date',
            userDetails: 'User Details'
        },
    },
    deletedUsersPage: {
        buttons: {
            downloadCsv: 'Export to CSV',
            downloadCsvForOrganizations: 'Export deleted users for the selected organizational units',
            restoreUsers: 'Restore users',
        }
    },
    restoreUsersModal: {
        title: 'Restore deleted users',
        resultsTitle: 'Restore results',
        confirmMessage: (key, {userCount}) => `You are about to restore ${userCount} user(s). Continue?`,
        confirmHint: 'Restored users will be reassigned to their previous organizations.',
        restoreUsers: 'Restore users',
        restoring: 'Restoring...',
        restoreError: 'An error occurred while restoring users. Please try again.',
        successMessage: (key, {restored}) => `Successfully restored ${restored} user(s)`,
        noRestoredMessage: 'No users were restored',
        restoredUsersTitle: 'Restored users',
        skippedUsersTitle: 'Skipped users',
        skippedExplanationTitle: 'Why were some users skipped?',
        skippedExplanation: 'Some users could not be restored due to internal errors. Try again or contact support if the problem persists.',
        firstName: 'First name',
        lastName: 'Last name',
        email: 'Email',
        employeeID: 'Employee ID',
        idNumber: 'ID number',
        organizations: 'Organizations',
        skipReason: 'Reason',
        reasons: {
            restore_failed: 'An error occurred during restore',
        },
    },
    deletedUserModal: {
        title: 'The documents and courses that were associated with',
        columns: {
            docName: 'Task Name',
            status: 'Status',
            completedOnDate: 'Completion Date',
            expiryDate: 'Expiry Date',
            type: 'Task Type',
            category: 'Category',
            score: 'Score',
            actions: 'Actions',
        },
        status: {
            finished: 'Finished',
            inProgress: 'In Progress',
            waitingForApproval: 'Waiting for Approval',
            notStarted: 'Not Started',
            signed: "Signed"
        },
        signDocData: {
            unCompletedCourse: 'The task was not completed',
            completedByAdmin: 'Completed by company admin',
            doNotForceCompletion: 'Enrichment'
        }
    },
    userDetailsModal: {
        learningPath: {
            expandTasks: 'Show learning path tasks',
            collapseTasks: 'Hide learning path tasks'
        },
        progressSummary: {
            title: 'Progress Summary',
            completed: 'Completed',
            inProgress: 'In Progress',
            notStarted: 'Not Started',
            tasksCompleted: 'tasks completed'
        },
        statusFilter: {
            archived: 'Archived'
        },
        archivedTag: 'Archived',
        actions: {
            updateExpiryDate: 'Update Expiry Date',
            declineApproval: 'Decline Approval',
            markAttended: 'Mark as Attended',
            markNoShow: 'Mark as No Show'
        }
    },
    FirstLoginModal: {
        title: 'How exciting to start learning together!',
        content: 'You need to complete the open tasks on the home screen by the target date.\n' +
            'Good luck!',
        takeMeHome: 'Great, take me to the home screen'
    },
    organizationalUnitTable: {
        columns: {
            organizationalUnitName: 'Organizational Unit Name',
            createAt: 'Created At',
            details: 'Details',
            delete: 'Delete',
            userCount: 'Number of Users',
            updateOrgName: "Update Organization Name",
        },
        removeOrgCell: {
            columns: {
                firstName: 'First Name',
                lastName: 'Last Name',
                organizationChange: 'Change Organizational Unit',
                deleteUser: 'Delete User'
            },
            modalNotAllowedDeleteTitle: 'To delete an organizational unit, you must reassign all users to at least one other unit or delete them.',
            modalAllowDeleteTitle: 'There are no users in the organization, you are allowed to delete it.',
            button: 'Delete Organizational Unit',
            tooltipMessage: 'To delete an organization, you must remove or reassign all users in it.',
            alertErrorDeleteOrgTitle: 'Error Deleting Organization',
            failedDeleteOrgError: 'We could not delete the organization, sorry! Please refresh the page and try again.'
        },
        editOrgNameCell: {
            button: 'Update organization name',
        }
    },
    questionnaire: {
        buttons: {
            continueToQuestionPool: 'Save and continue to edit questions',
        },
        modal: {
            title: 'Create a new questionnaire',
            passGrade: 'Passing grade',
            timeToFinish: 'Exam time',
            canUserReview: 'Allow the examinee to review answers',
            allowedTries: 'Allowed attempts'
        }
    },
    questionnaireQuestions: {
        questionText: 'Question Text',
        questionType: 'Question Type',
        options: 'Options',
        markAsCorrect: 'Mark as correct answer',
        addOption: 'Add option',
        validation: {
            modalTitle: 'Please fix the following errors before saving the exam',
            questionIndexError: 'Error in question number',
            closeAndFix: 'Close and fix',
            navigateToQuestion: 'Go to question',
            minimumOptions: 'There are fewer than 2 possible correct answers for the question',
            noCorrectAnswer: 'No correct answer was selected for the question',
            duplicateOptions: 'There are 2 options with identical answers',
        },
        aiLoadingTexts: {
            loading: 'Generating questions for you...',
            pleaseWait: 'Please wait...',
            testWillBeReadySoon: 'Your exam will be ready soon...',
            aBitMorePatience: 'Just a bit more patience...',
            itMightTakeABitLongerButItsWorthIt: `This might take a few more seconds, but it'll be worth it...`,
        },
        tooltip: {
            pleaseFillSubject: 'Please fill in the exam subject',
        },
        placeHolders: {
            questionText: 'Enter your question here...',
            subject: '*Exam subject',
            description: 'Short description',
            question: 'Question',
            FREE_TEXT: 'Short answer text',
            option: 'Option',
            NO_ANSWER: 'This section is for informational purposes only and has no answer',
            questionCount: 'Number of questions',
        },
        question: 'Question',
        FREE_TEXT: 'Short answer text',
        option: 'Option',
        NO_ANSWER: 'This section is for informational purposes only and has no answer',
        messages: {
            deleteLastQuestion: 'Cannot delete the last question',
        },
        headers: {
            poolQuestion: 'Edit Exam',
            poolQuestionSubTitle: 'Number of questions created for the exam',
        },
        buttons: {
            addOption: 'Add option +',
            saveQuestions: 'Save questions',
            saveQuestionsSubTitle: 'Save all questions in the exam',
            genAIQuestions: 'Generate AI Questions',
        },
        aiModal: {
            questionQuantityLabel: 'Number of questions to generate',
        },
        questionOptions: {
            MULTIPLE_CHOICE: 'Single choice',
            CHECKBOX: 'Multiple choice',
            FREE_TEXT: 'Open question',
            NO_ANSWER: 'Short paragraph',
            RATING_SCALE: 'Rating Scale',
        },
        survey: {
            anonymousToggle: 'Anonymous Survey',
            anonymousDescription: 'When enabled, user details who filled the survey will not be saved',
            ratingScale: {
                title: 'Rating Scale Settings',
                minValue: 'Minimum Value',
                maxValue: 'Maximum Value',
                minLabel: 'Minimum Label',
                maxLabel: 'Maximum Label',
                defaultMinLabel: 'Not Satisfied',
                defaultMaxLabel: 'Very Satisfied',
                previewTitle: 'Preview',
            }
        },
        addImage: 'Add Image to Question',
        hasImage: 'Question contains an image',
        dropImageOrClick: 'Drag image here or click to select',
        uploading: 'Uploading image...',
        supportedFormats: 'Supported Formats',
        deleteImageTitle: 'Delete Image',
        confirmDeleteImage: 'Are you sure you want to delete the image?',
        errors: {
            invalidImageType: 'Unsupported file type. Please upload an image in JPG, PNG, GIF, or WEBP format',
            imageTooLarge: 'File size exceeds 10MB',
            uploadFailed: 'Image upload failed',
            deleteFailed: 'Image deletion failed',
        }
    },
    weezbeeCourse: {
        addContent: 'Add Content',
        contentType: 'Content Type',
        contentTypes: {
            text: 'Text',
            video: 'Video',
            image: 'Image',
            quiz: 'Quiz',
            pdf: 'PDF'
        },
        orientationOverlay: {
            title: 'Please Rotate Your Device',
            message: 'For the best experience, please rotate your device to landscape mode.'
        },
        fullscreenPrompt: {
            title: 'Show course in full screen',
            buttonText: 'Enter Full Screen',
            errors: {
                permissionDenied: 'Permission denied. Please try again by tapping the fullscreen button.',
                generic: 'Fullscreen error: {message}'
            }
        },
        chapterPanel: {
            title: 'Chapters',
            generating: 'Generating...',
            aiCreating: 'AI is creating this chapter...',
            deleteChapter: 'Delete Chapter',
            duplicateChapter: 'Duplicate Chapter',
            copySuffix: '(copy)',
        },
        question: {
            defaultText: 'Enter your question here',
            tryAgain: 'Oops, wrong answer. Try again!',
            submitAnswer: 'Submit Answer',
            correct: 'Correct!',
            incorrect: 'Incorrect',
        },
        navigation: {
            back: 'Back',
            next: 'Next'
        },
        aiGeneration: {
            generateCourse: 'Generate Course with AI',
            courseLengthMinutes: 'Course Length (minutes)',
            courseLengthMinutesHelp: 'Enter a value between 5-30 minutes',
            descriptionPlaceholder: 'Short description of the course...',
            tooltip: {
                pleaseEnterDescription: 'Please enter a description of the course (5-150 characters)',
                pleaseEnterValidCourseLength: 'Please enter a valid course length (5-30 minutes)'
            },
            loadingTexts: {
                loading: 'Generating course for you...',
                pleaseWait: 'Please wait...',
                courseWillBeReadySoon: 'Your course will be ready soon...',
                aBitMorePatience: 'Just a bit more patience...',
                itMightTakeABitLongerButItsWorthIt: 'This might take a few more seconds, but it will be worth it...',
            },
        },
        aiWizard: {
            openWizardButton: 'Create Course with AI',
            wizardTitle: 'AI Course Generator Wizard',
            step1Label: 'Course Details',
            step2Label: 'Select Template',
            subjectLabel: 'Course Subject',
            subjectPlaceholder: 'Enter the main topic of your course...',
            promptLabel: 'Additional AI Instructions (Optional)',
            promptPlaceholder: 'Provide any specific instructions for the AI...',
            uploadFileButton: 'Upload Reference File (PDF/TXT)',
            fileUploaded: 'File uploaded: {fileName}',
            removeFile: 'Remove file',
            characterLimitExceeded: 'Character limit exceeded. Please reduce content.',
            subjectRequired: 'Course subject is required',
            validationError: 'Please fix errors before proceeding',
            fileTooLarge: 'File is too large. Maximum size: {maxSize}MB',
            unsupportedFileType: 'Unsupported file type. Please upload a PDF or TXT file',
            fileReadError: 'Error reading file. Please try again',
            extractingFile: 'Extracting text from file...',
            extractError: 'Error extracting text from file',
            generateButton: 'Generate Course',
            generatingButton: 'Generating...',
        },
        aiContextGenerator: {
            title: 'AI Context',
        },
        content: {
            title: 'Title',
            description: 'Description',
            text: 'Text Content',
            videoUrl: 'Video URL',
            addQuestion: 'Add Question',
            question: 'Question',
            option: 'Option {number}',
            correctAnswer: 'Correct Answer'
        },
        editor: {
            pagination: {
                pageInfo: (key, {current, total}) => `Page ${current} of ${total}`
            },
            backgroundSelector: {
                image: 'Image',
                video: 'Video'
            },
            addSection: 'Add Section',
            editSection: 'Edit Section',
            preview: 'Preview',
            switchToViewMode: 'Switch to view mode',
            switchToEditMode: 'Switch to edit mode',
            enterFullscreen: 'Fullscreen',
            exitFullscreen: 'Exit fullscreen',
            saveCourse: 'Save Course',
            saveCourseSubTitle: 'Click to save the course',
            previewMode: 'Preview Mode',
            editMode: 'Edit Mode',
            templateMode: 'Template Mode',
            courseMode: 'Course Mode',
            switchToTemplateMode: 'Switch to Template Mode',
            switchToCourseMode: 'Switch to Course Mode',
            templateDetails: 'Course Template Configuration',
            templateName: 'Template Name',
            templateSubject: 'Category / Subject Area',
            templateDescription: 'Template description',
            templateTags: 'Tags (comma separated)',
            templatePublic: 'Publicly Accessible',
            templateReady: 'Ready for Use',
            saveTemplate: 'Save Template',
            templateValidationError: 'Template name and subject are required',
            templateSaved: 'Template saved successfully!',
            templateUpdated: 'Template updated successfully!',
            templateSaveError: 'Error saving template. Please try again.',
            templateCreateError: 'Error creating new template. Please try again.',
            fetchError: 'Error loading course or template. Please try again.',
            defaultCourseTitle: 'Course',
            defaultCourseDescription: '',
            templateNamePlaceholder: 'Enter a descriptive title for this template',
            templateSubjectPlaceholder: 'E.g., Safety Training, Onboarding, Leadership',
            templateDescriptionPlaceholder: 'Provide a detailed description of what this template covers and who it\'s designed for',
            templateTagsPlaceholder: 'Add keywords to help users find this template (comma separated)',
            templateSelectorTitle: 'Create or Select a Template',
            createNewTemplate: 'Create New Template',
            createNewTemplateDesc: 'Start with a blank template and build it from scratch.',
            createTemplate: 'Create Template',
            selectExistingTemplate: 'Select Existing Template',
            selectExistingTemplateDesc: 'Choose from your existing templates to edit.',
            browseTemplates: 'Browse Templates',
            publicAssetBank: 'Public Asset Bank',
            publicAssetBankDescription: 'Assets added here will be available to all templates',
            uploadPublicAsset: 'Upload Public Asset',
            publicAssetUploaded: 'Public asset uploaded successfully!',
            publicAssetUploadError: 'Error uploading public asset. Please try again.',
            templateAssetName: 'Template Asset',
            templateAssetDescription: 'Uploaded from template editor',
            componentBank: {
                title: 'Component Bank',
                description: 'Drag or click to add components',
                text: {
                    name: 'Text',
                    description: 'Simple text component'
                },
                bullets: {
                    name: 'Bullets',
                    description: 'Bullet list component'
                },
                logo: {
                    name: 'Logo',
                    description: 'Company logo component',
                    missingLogo: 'Company logo is missing'
                },
                image: {
                    name: 'Image',
                    description: 'Image component'
                },
                video: {
                    name: 'Video',
                    description: 'Video component'
                },
                shape: {
                    name: 'Shape',
                    description: 'Basic shapes component'
                },
                question: {
                    name: 'Question',
                    description: 'Interactive question component'
                }
            },
            chapterEditor: {
                title: 'Chapter Editor',
                description: 'Edit your chapter content',
                contentTitle: 'Canvas',
                canvasDescription: 'Drag components onto the canvas and position them freely',
                emptyState: 'No components added yet. Drag components from the bank or click to add.',
                removeComponent: 'Remove Component'
            },
            textComponent: {
                placeholder: 'Enter your text here...',
                emptyState: 'Click to add text'
            },
            bulletsComponent: {
                placeholder: 'Enter bullet text...',
                emptyState: 'Empty bullet',
                removeBullet: 'Remove bullet',
                addBullet: 'Add bullet'
            },
            logoComponent: {
                altText: 'Company Logo',
                missingLogo: 'Company logo is missing',
                borderRadius: 'Border Radius',
                backgroundColor: 'Background Color',
                opacity: 'Opacity'
            },
            imageComponent: {
                altText: 'Image',
                placeholder: 'Click to add image',
                selectorTitle: 'Select Image',
                uploadNew: 'Upload New',
                imageBank: 'Image Bank',
                loading: 'Loading...',
                emptyBank: 'No images in bank',
                cancel: 'Cancel',
                enterUrl: 'Enter URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Submit',
                changeSource: 'Change Image'
            },
            backgroundImageComponent: {
                altText: 'Background Image',
                placeholder: 'Click to add background image',
                selectorTitle: 'Select Background Image',
                uploadNew: 'Upload New',
                imageBank: 'Image Bank',
                loading: 'Loading...',
                emptyBank: 'No images in bank',
                cancel: 'Cancel',
                enterUrl: 'Enter URL',
                urlPlaceholder: 'https://example.com/image.jpg',
                submit: 'Submit',
                changeSource: 'Change Background Image'
            },
            videoComponent: {
                altText: 'Video',
                placeholder: 'Click to add video',
                selectorTitle: 'Select Video',
                uploadNew: 'Upload New',
                videoBank: 'Video Bank',
                loading: 'Loading...',
                emptyBank: 'No videos in bank',
                cancel: 'Cancel',
                enterUrl: 'Enter URL',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Submit',
                changeSource: 'Change Video',
                errorTitle: 'Video Failed to Load',
                errorMessage: 'The video could not be loaded. Please upload a new video or select another one from the video bank.',
                retry: 'Retry',
                selectAnother: 'Select Another Video',
                edit: 'Edit'
            },
            shapeComponent: {
                emptyState: 'Click to select a shape',
                rectangle: 'Rectangle',
                circle: 'Circle',
                triangle: 'Triangle',
                star: 'Star'
            },
            color: {
                placeholder: '#000000'
            },
            component: {
                borderRadius: 'Border Radius',
                backgroundColor: 'Background Color',
                opacity: 'Opacity',
                textDirection: 'Text Direction',
                leftToRight: 'Left to Right',
                rightToLeft: 'Right to Left',
                pixelUnit: 'px',
                percentUnit: '%',
                colorValue: (key, { color }) => color,
                backgroundColorValue: (key, { color }) => color,
                borderRadiusAll: 'All'
            },
            editorDrawer: {
                title: 'Edit Component',
                closeButton: 'Close',
                description: 'Customize the selected component',
                typography: 'Typography',
                textFormatting: 'Text Formatting',
                fontSize: 'Font Size',
                textColor: 'Text Color',
                shapeType: 'Shape Type',
                shapeColor: 'Shape Color',
                shapeBackground: 'Shape Background',
                colorMode: 'Color',
                gradientMode: 'Gradient',
                gradientColor1: 'First Color',
                gradientColor2: 'Second Color',
                gradientAngle: 'Gradient Angle',
                borderGradientColor1: 'First Color',
                borderGradientColor2: 'Second Color',
                borderGradientAngle: 'Gradient Angle',
                shapeOpacity: 'Shape Opacity',
                borderWidth: 'Border Width',
                borderColor: 'Border Color',
                border: 'Border',
                style: 'Style',
                background: 'Background'
            },
            backgroundImage: {
                label: 'Background Image',
                placeholder: 'Enter image URL',
                uploadButton: 'Upload Image',
                previewAlt: 'Background Preview',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Invalid+Image+URL'
            },
            logoImage: {
                label: 'Logo',
                placeholder: 'Enter logo URL',
                uploadButton: 'Upload Logo',
                previewAlt: 'Logo Preview',
                invalidImageUrl: 'https://via.placeholder.com/400x200?text=Invalid+Logo+URL'
            },
            backgroundImageEditor: {
                title: 'Edit Background Image',
                opacity: 'Opacity',
                backgroundColor: 'Background Color',
                transparent: 'Transparent',
                save: 'Save Changes',
                remove: 'Remove Background Image',
                cancel: 'Cancel'
            },
            backgroundVideoEditor: {
                title: 'Edit Background Video',
                opacity: 'Opacity',
                backgroundColor: 'Background Color',
                transparent: 'Transparent',
                save: 'Save Changes',
                remove: 'Remove Background Video',
                cancel: 'Cancel'
            },
            backgroundVideoComponent: {
                changeSource: 'Change Video Source',
                enterUrl: 'Enter Video URL',
                urlPlaceholder: 'https://example.com/video.mp4',
                submit: 'Apply',
                cancel: 'Cancel',
                uploadNew: 'Upload New Video',
                loading: 'Loading...',
                videoBank: 'Video Bank',
                backgroundVideoBank: 'Background Video Bank',
                emptyBank: 'No videos found in the video bank.'
            },
            videoUrl: {
                label: 'Video URL',
                placeholder: 'Enter YouTube or video URL'
            },
            // Default values for new chapters
            headTitle: {
                label: 'Head Title',
                defaultValue: 'New Chapter'
            },
            textContent: {
                label: 'Text Content',
                defaultValue: 'Enter your content here',
                placeholder: 'Enter your content here'
            },
            bullets: {
                defaultValue1: 'Point 1',
                defaultValue2: 'Point 2',
                defaultValue3: 'Point 3'
            },
            title: {
                defaultValue: 'New Chapter'
            },
            description: {
                defaultValue: 'Chapter description'
            },
            // Template selection
            templateSelectionInstruction: 'Select a template for your new chapter:',
            featureBadges: {
                video: 'Video',
                bullets: 'Bullets',
                textContent: 'Text Content',
                'text-content': 'Text Content',
                heading: 'Heading'
            }
        },
        templateBank: {
            title: 'Choose a Template',
            description: 'Select a template for your new chapter',
            closeButton: 'Close template bank',
            selectTemplate: (key, { templateName }) => `Select ${templateName} template`,
            directionSelection: 'Select template direction:',
            ltrDirection: 'Left-to-Right direction',
            rtlDirection: 'Right-to-Left direction',
            ltrLabel: 'LTR',
            rtlLabel: 'RTL',
            templates: {
                standardSlide: {
                    name: 'Standard Slide',
                    description: 'A standard slide with logo, title, text on the right, and image on the left'
                },
                videoFocused: {
                    name: 'Video Focused',
                    description: 'A slide with a large video in the center and supporting text below'
                },
                bulletPoints: {
                    name: 'Bullet Points',
                    description: 'A slide focused on bullet points for key information'
                },
                centeredImage: {
                    name: 'Centered Image',
                    description: 'A slide with a large centered image and caption text below'
                },
                textAndBullets: {
                    name: 'Text and Bullets',
                    description: 'A slide with text on the left and bullet points on the right'
                },
                videoAndBullets: {
                    name: 'Video and Bullets',
                    description: 'A slide with a video on the left and bullet points on the right'
                },
                twoColumnImage: {
                    name: 'Two-Column Image',
                    description: 'A slide with two images side by side and a caption below'
                },
                threeColumnText: {
                    name: 'Three-Column Text',
                    description: 'A slide with three text columns for comparing or listing related information'
                },
                imageGallery: {
                    name: 'Image Gallery',
                    description: 'A slide with four images arranged in a grid with a caption below'
                },
                videoWithOverlay: {
                    name: 'Video with Overlay',
                    description: 'A slide with a video and text overlay for highlighting key points'
                },
                titleWithBackground: {
                    name: 'Title with Background',
                    description: 'A slide with a title and text over a background image for dramatic effect'
                }
            },
            content: {
                slideTitle: 'Slide Title',
                loremIpsum: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam auctor, nisl eget ultricies tincidunt, nisl nisl aliquam nisl, eget ultricies nisl nisl eget nisl.',
                videoTitle: 'Video Presentation',
                videoDescription: 'This video explains the key concepts of the topic. Watch it carefully to understand the main ideas.',
                bulletTitle: 'Key Points',
                bullet1: 'First important point to remember about this topic',
                bullet2: 'Second key concept that builds on the first point',
                bullet3: 'Third essential element that completes the understanding',
                imageTitle: 'Visual Representation',
                imageCaption: 'This image illustrates the concept described in this chapter. Study it carefully to understand the visual elements.',
                textBulletTitle: 'Concept Overview',
                textContent: 'This section provides a detailed explanation of the concept. The text introduces the main ideas and provides context for understanding the key points listed on the right.',
                textBullet1: 'Key point related to the concept explained in the text',
                textBullet2: 'Additional information that supports the main concept',
                textBullet3: 'Final point that completes the understanding of the topic',
                videoBulletTitle: 'Video Tutorial with Key Points',
                videoBullet1: 'Watch the video to understand the demonstration',
                videoBullet2: 'Follow along with the steps shown in the video',
                videoBullet3: 'Refer to these bullet points while watching the video',

                // Two-column image template content
                twoColumnImageTitle: 'Image Comparison',
                twoColumnImageCaption: 'These images illustrate different aspects of the concept. Compare them to understand the key differences and similarities.',

                // Three-column text template content
                threeColumnTitle: 'Three-Step Process',
                column1Text: 'Step 1: Begin by understanding the basic principles and foundations of the concept. This initial phase is crucial for building a solid understanding.',
                column2Text: 'Step 2: Apply the principles in practical scenarios and explore how they interact with real-world situations. Practice is essential for mastery.',
                column3Text: 'Step 3: Evaluate your understanding and refine your approach based on feedback and results. Continuous improvement leads to expertise.',

                // Image gallery template content
                imageGalleryTitle: 'Visual Examples Gallery',
                imageGalleryCaption: 'This collection of images demonstrates various aspects of the topic. Each image represents a different example or application.',

                // Video with overlay template content
                videoOverlayTitle: 'Video with Key Highlights',
                videoOverlayText: 'IMPORTANT: Pay special attention to this demonstration as it shows critical techniques.',

                // Title with background template content
                backgroundTitle: 'Chapter Overview',
                backgroundSubtitle: 'Essential concepts and principles',
                backgroundText: 'This chapter introduces fundamental concepts that form the foundation of the subject. Understanding these principles is crucial for mastering the more advanced topics that follow.'
            }
        },
        courseTemplateBank: {
            title: 'Create Course with AI',
            description: 'Select a course template to create a new course with AI-generated content',
            courseTemplatesTitle: 'Course Templates',
            chapterTemplatesTitle: (key, { count }) => `Included Slides (${count})`,
            slideCount: (key, { count }) => `${count} slides`,
            defaultCourseTitle: 'New Course',
            defaultCourseDescription: 'Course created with AI',
            defaultSectionTitle: 'Section 1',
            cancelButton: 'Cancel',
            createButton: 'Create Course',
            yourDescription: 'Your Course Description:',
            defaultTemplatesTab: 'Default Templates',
            designedTemplatesTab: 'Designed Templates',
            loadingTemplates: 'Loading templates...',
            noDesignedTemplates: 'No designed templates are currently available.',
            estimatedDuration: (key, { duration }) => `${duration} min`,
            noDescription: 'No description available',
            noPreviewAvailable: 'No preview available',
            generationStartError: 'An error occurred while starting course generation. Please try again.',
            courseTypes: {
                business: 'Business',
                technical: 'Technical',
                educational: 'Educational',
                onboarding: 'Onboarding',
                compliance: 'Compliance',
                product: 'Product'
            },
            templates: {
                businessCourse: {
                    name: 'Business Course',
                    description: 'A comprehensive business course template with slides covering key business concepts, strategies, and case studies'
                },
                technicalCourse: {
                    name: 'Technical Course',
                    description: 'A detailed technical course template with slides covering technical concepts, demonstrations, and practical examples'
                },
                educationalCourse: {
                    name: 'Educational Course',
                    description: 'A structured educational course template with slides designed for effective learning and knowledge retention'
                },
                onboardingCourse: {
                    name: 'Onboarding Course',
                    description: 'An onboarding course template with slides to introduce new employees to company policies, procedures, and culture'
                },
                complianceCourse: {
                    name: 'Compliance Course',
                    description: 'A compliance course template with slides covering regulatory requirements, best practices, and compliance procedures'
                },
                productCourse: {
                    name: 'Product Course',
                    description: 'A product training course template with slides showcasing product features, benefits, and usage examples'
                }
            }
        }
    },
    AIGeneration: {
        titles: {
            WEEZBEE_COURSE: 'Create Course with AI',
            EXAM: 'Create Exam with AI',
            SURVEY: 'Create Survey with AI',
            default: 'Create Content with AI',
        },
        buttonText: {
            WEEZBEE_COURSE: 'Create Course with AI',
            EXAM: 'Generate Questions with AI',
            SURVEY: 'Generate Questions with AI',
            default: 'Create with AI',
        }
    },
    questionnaireSession: {
        imageLoadError: 'Failed to load image',
        modal: {
            finishExam: 'Are you sure you want to finish the exam?',
            finishExamTitle: 'Finish Exam',
            finishExamWithUnansweredQuestions: 'Are you sure you want to finish? There are unanswered questions',
            closeAndReturnToTest: 'Return to exam'
        },
        finishModal: {
            congratsTitle: 'Well done!',
            congratsMessage: 'You passed the exam successfully',
            oopsTitle: 'Oops...',
            oopsMessage: 'It seems you did not pass the exam',
        },
        buttons: {
            previousQuestion: 'Previous question',
            nextQuestion: 'Next question',
            finishExam: 'Finish exam',
            congratsModal: 'Great, take me to the home screen',
            oopsBackToHomePage: 'Back to home screen',
        },
        errors: {
            notAllQuestionsAnswered: 'Not all questions are answered. Are you sure you want to finish?',
        },
    },
    surveySession: {
        finishModal: {
            congratsTitle: 'Thank you!',
            congratsMessage: 'Thank you for participating in the survey! \n Your contribution is very important to us.',
        },
        defaultTitle: "Survey",
        buttons: {
            previousQuestion: "Previous question",
            nextQuestion: "Next question",
            finishSurvey: "Finish Survey",
            congratsModal: 'Great, take me to the home screen',
        },
        placeHolders: {
            FREE_TEXT: 'Your answer',
        },
        modal: {
            finishSurveyTitle: "Finish Survey",
            finishSurvey: "Are you sure you want to finish the survey? You can go back and change answers before finishing.",
            closeAndReturnToSurvey: "Return to survey"
        },
        success: {
            title: "Thank you!",
            anonymousMessage: "Your answers have been saved anonymously",
            identifiedMessage: "Your answers have been successfully saved in the system",
            thankYou: "Thank you for participating in the survey! Your contribution is very important to us.",
            anonymousConfirmation: "Your information has been saved anonymously and you cannot be identified",
            goHome: "Back to home page"
        }
    },
    surveyInstruction: {
        title: 'Before we begin, a few notes...',
        info1: (key, { numberOfQuestions }) => `The survey consists of ${numberOfQuestions} questions`,
        info2: 'We would love to hear your opinion',
        info3: 'Participation in the survey is voluntary',
        info4: 'You may skip any questions you prefer not to answer',
        anonymous: 'The survey is completely anonymous',
        anonymousNotice: 'Your responses are saved anonymously and cannot be linked to you',
        thankYou: 'Thank you for your participation!',
        startButton: 'Start Survey'
    },
    questionnaireInstruction: {
        title: 'Before we begin, a few notes...',
        info1: (key, { numberOfQuestions }) => `The exam consists of ${numberOfQuestions} questions`,
        info2: (key, { passGrade }) => `Passing grade for the exam - ${passGrade}`,
        info3: 'Please answer all questions before submitting',
        successInfo: 'Passed? ',
        failInfo: "Didn't pass? ",
        info4: 'Great job, you finished the task. ',
        info5: 'A retake is required',
        goodLuck: 'Good luck!',
        startButton: 'Start'
    },
    signDoc: {
        finishByDuration: {
            toggleLabel: 'Set time to complete task',
            title: 'Time to Complete',
            note: 'Number of days the user has to complete the task from the time of assignment'
        },
        assignmentWarning: {
            title: 'Assignment Warning',
            editingWillBeLocked: 'Warning: Once this document is assigned to organizational units, question editing will be locked to preserve training integrity.',
            editingLocked: 'Please note: Editing questions is not allowed due to prior assignments to organizational units.',
            continueAssignment: 'Continue Assignment',
            cancel: 'Cancel'
        },
        editDisabled: {
            assignedToOrganizations: 'Editing is disabled because this document has been assigned to organizational units. This preserves training integrity and ensures consistent evaluation.',
            editQuestionsDisabled: 'Edit Questions is disabled for documents assigned to organizational units'
        },
        duplicate: {
            button: 'Duplicate as Editable Copy',
            modal: {
                title: 'Duplicate SignDoc',
                description: 'Create a new editable copy of this document with all its questions.',
                newNameLabel: 'New Document Name',
                newNamePlaceholder: 'Copy of {originalName}',
                newDescriptionLabel: 'New Document Description (Optional)',
                newDescriptionPlaceholder: 'Copy of the original document',
                duplicate: 'Create Duplicate',
                cancel: 'Cancel'
            },
            success: 'Document duplicated successfully! You can now edit the new copy.',
            error: 'Failed to duplicate document. Please try again.'
        },
        questionSection: {
            pleaseSelectAnswer: 'Please select an answer',
            correct: 'Correct! Your answer is right.',
            incorrect: 'Incorrect. Please try again.',
            submitError: 'Error submitting answer. Please try again.',
            submit: 'Submit Answer',
            alreadyCompleted: 'You have already answered this question successfully'
        },
        sequentialActiveVersionModal: {
            title: 'Replace Active Version?',
            message: (key, {activeVersionName}) => `"${activeVersionName}" is the current active version for this recurring content.`,
            subMessage: 'Only one version can be active at a time. Activating this version will archive the previous one. Users assigned to the previous version will also be assigned to the new version, and the previous version will appear in their archive.',
            declineButton: 'Cancel',
            agreeButton: 'Replace & Activate'
        }
    },
    learningManagement: {
        createEditNewSignDocModal: {
            approversSection: {
                title: 'Select Approvers (Optional)',
                description: 'Select specific users who can approve uploads. If not selected, all admins of the assigned organizational units will be approvers.',
                userLabel: 'Select specific users as approvers',
                defaultInfo: 'If no specific users are selected, only you or company administrators will be able to approve uploads'
            },
            individualUsersSection: {
                title: 'Assign to Individual Users',
                userLabel: 'Search users for individual assignment',
                searchLabel: 'Search Users',
                searchPlaceholder: 'Type name, phone or email...',
                noUsersFound: 'No users found matching your search',
            },
            // Organization search
            organizationsSection: {
                searchLabel: 'Search Organization',
                searchPlaceholder: 'Type organization name...',
            },
            // User pagination labels
            noUsers: 'No users found',
            selectedLabel: 'users selected',
            noOrganizations: 'No organizations found',
            selectedOrgsLabel: 'organizations selected',
            userPaginationError: 'Error Loading Users',
            userPaginationErrorMessage: 'Unable to load users list. Please try again using the navigation arrows.',
            orgPaginationError: 'Error Loading Organizations',
            orgPaginationErrorMessage: 'Unable to load organizations list. Please try again using the navigation arrows.',
            uploadError: 'File Upload Failed',
            uploadErrorMessage: 'Upload failed. Please try again.'
        }
    },
    pendingApprovals: {
        title: 'Pending Approvals',
        description: 'Review and approve or reject user document uploads',
        searchPlaceholder: 'Search by user name or task...',
        noData: 'No pending approvals',
        tabs: {
            documentApprovals: 'Document Approvals',
            courseAttendance: 'Course Attendance'
        },
        columns: {
            userName: 'User Name',
            phone: 'Phone',
            idNumber: 'ID Number',
            signDocName: 'Task Name',
            uploadDate: 'Upload Date',
            organization: 'Organization',
            files: 'Files',
            actions: 'Actions'
        },
        actions: {
            approve: 'Approve',
            reject: 'Reject'
        },
        approveDialog: {
            title: 'Approve Upload',
            user: 'User',
            signDoc: 'Task',
            confirmMessage: 'Approve this upload?',
            expiryDescription: 'This certification requires manual expiry date entry. Select the date when the certification will expire.',
            expiryDateLabel: 'Certification Expiry Date',
            expiryDateRequired: 'Expiry date is required for certification',
            expiryDatePast: 'Expiry date must be in the future',
            cancel: 'Cancel',
            confirm: 'Approve Upload'
        },
        rejectDialog: {
            title: 'Reject Upload',
            reasonLabel: 'Rejection Reason (Optional)',
            reasonPlaceholder: 'Explain to the user why the upload was rejected...',
            deleteFilesLabel: 'Delete uploaded files from server',
            cancel: 'Cancel',
            confirm: 'Reject Upload'
        },
        errors: {
            approveFailed: 'Error approving upload. Please try again.',
            rejectFailed: 'Error rejecting upload. Please try again.'
        }
    },
    courseAttendance: {
        title: 'Course Attendance',
        description: 'Mark attendance or no-show for users enrolled in courses',
        searchPlaceholder: 'Search by user name or course...',
        noData: 'No courses pending attendance marking',
        columns: {
            userName: 'User Name',
            phone: 'Phone',
            idNumber: 'ID Number',
            courseName: 'Course Name',
            courseType: 'Course Type',
            sessionDate: 'Session Date',
            actions: 'Actions'
        },
        courseTypes: {
            frontal: 'Frontal',
            online: 'Online'
        },
        actions: {
            markAttended: 'Mark Attended',
            markNoShow: 'Mark No-Show'
        },
        tooltips: {
            sessionNotToday: 'Attendance can only be marked on the day of the session'
        },
        errors: {
            markAttendedFailed: 'Error marking attendance. Please try again.',
            markNoShowFailed: 'Error marking no-show. Please try again.'
        },
        filters: {
            allCourses: 'All Courses'
        }
    },
    partnersTable:{
        columns: {
            partnerName: 'Partner Name',
            generateAPIKey: 'Generate API Key',
            edit: 'Edit',
        }
    },
    reports: {
        title: 'Reports',
        tabs: {
          companies: 'Companies',
        },
        companiesInfo: {
            totalUsersCount: 'Total active users in the system',
            newUsersThisMonthCount: 'New users this month',
            totalCompaniesCount: 'Total companies in the system',
            newCompaniesThisMonthCount: 'New companies this month',
            columns: {
                companyName: 'Company Name',
                userQuota: 'User Quota',
                activeUsers: 'Active Users',
                createdAt: 'Created At',
                organizations: 'Number of Organizational Units',
                admins: 'Number of System Admins',
                courses: 'Number of Courses and Documents',
                assignmentCompletion: 'Task Completion Percentage',
                lastMemoSentDate: 'Last Reminder Sent Date',
                smsCount: 'Number of Messages Sent',
                smsQuota: 'Number of Messages Remaining',
                lastAdminLoginDate: 'Last Admin Login Date',
                adminIdentifier: 'Admin Identifier',
            }
        }
    },
    learningPath: {
        sequentialOnlyDisclaimer: 'This learning path is defined as "recurring" - only recurring tasks can be added',
        freePath: {
            checkboxLabel: 'Free path — pick tasks in any order',
            checkboxHelper: 'When enabled, assigned users can start any task immediately and complete them in any order. When disabled, tasks must be completed sequentially.',
            adminBanner: 'Free-path mode is enabled. Assigned users can complete tasks in any order.',
            confirmSwitchToOrderedTitle: 'Switch to sequential task order?',
            confirmSwitchToOrderedBody: 'This LearningPath is currently free-order and already assigned. Switching to sequential means assigned users will be required to complete tasks in the defined order. Users who already completed tasks out of order will keep their progress, but their next available task will be the first incomplete one in the sequence — which may feel unexpected. Are you sure?',
            confirmSwitchToOrderedConfirm: 'Switch to sequential',
            badge: 'Free path',
        },
    },
    HoneycombTasks: {
        servicesText: {
            READ_AND_SIGN_DOC_PDF: 'Document',
            WATCH_AND_SIGN_YOUTUBE_LINK: 'Video',
            WATCH_AND_SIGN_VIMEO_LINK: 'Video',
            WATCH_AND_SIGN_VIDEO_FILE: 'Video',
            AUDIO_FILE: 'Audio File',
            REGULAR_COURSE: 'Course',
            CANVA_PRESENTATION: 'Presentation',
            EXAM: 'Exam',
            LEARNING_PATH: 'Learning Path',
            PODCAST: 'Podcast',
            FRONTAL_COURSE: 'Frontal Lecture',
            ONLINE_COURSE: 'Online Course',
            PRESENTATION: 'Presentation',
            ARTICLE: 'Article',
            SURVEY: 'Survey',
            LINK: 'Link',
            UPLOAD_DOCUMENT: 'Upload Document',
        },
    },
    userProgressReport: {
        exportToExcel: 'Export to Excel',
        exporting: 'Exporting...',
        exportCurrentFilters: 'Export current filters',
        columns: {
            fullName: 'Full Name',
            firstName: 'First Name',
            lastName: 'Last Name',
            phone: 'Phone',
            idNumber: 'ID Number',
            employeeId: 'Employee ID',
            chosenOrganizationUnitsProgress: 'Task Progress in Selected Units',
            allManagedProgress: 'Progress in All Tasks',
            completionStatus: 'Completion Status',
            organizations: 'Organizations',
            userDetails: 'User Details'
        },
        completionStatus: (key, { completed, total }) => `${completed} out of ${total} completed`,
        tasksCompleted: 'tasks completed',
        pieChart: {
            title: 'Overall Employee Task Performance in the Organization',
            subtitle: 'Task Distribution by Status',
            selectedOrgsTitle: 'Employee Progress Percentage in Selected Units',
            selectedOrgsSubtitle: 'Task Distribution in Selected Units',
            selectedOrgsInfoBubble: 'This chart shows the task distribution for employees in the organizational units selected in the filters. It includes only tasks assigned to employees in the selected units.',
            allManagedTitle: 'Overall Task Progress Percentage for Employees in Selected Units',
            allManagedSubtitle: 'Distribution of All Tasks Under Management',
            allManagedInfoBubble: 'This chart shows the distribution of all tasks for employees in all organizational units you manage, regardless of the selected filters. It provides a comprehensive view of all tasks under your management.',
            completed: 'Completed Tasks',
            inProgress: 'Tasks in Progress',
            notStarted: 'Tasks Not Started',
            totalTasks: (key, { count = 0 } = {}) => `Total: ${count} tasks`
        }
    },
    certificationDashboard: {
        title: 'Certification Dashboard',
        subtitle: 'Track user certification status and expiry',
        tasksCompleted: 'Completed',
        columns: {
            fullName: 'Full Name',
            status: 'Status',
            phone: 'Phone',
            organizations: 'Organizations',
            idNumber: 'ID Number',
            employeeId: 'Employee ID',
            chosenOrganizationUnitsProgress: 'Selected Organizations Progress',
            allManagedProgress: 'All Managed Progress',
            userDetails: 'User Details',
        },
        pieChart: {
            selectedOrgsTitle: 'Selected Organizations Status',
            selectedOrgsSubtitle: 'Certification Status Distribution',
            selectedOrgsInfoBubble: 'Certification status for selected organizations',
            allManagedTitle: 'All Managed Organizations Status',
            allManagedSubtitle: 'Certification Status Distribution',
            allManagedInfoBubble: 'Certification status for all managed organizations',
        }
    },
    certificationStatus: {
        expired: 'Expired',
        expiringSoon: 'Expiring Soon',
        incomplete: 'Incomplete',
        completed: 'Completed',
    },
    videoPlayer: {
        pleaseEnterVideoUrl: 'Please enter video URL',
    },
    imageBank: {
        title: 'Company Image Bank',
        noImages: 'No images found in the company image bank.',
        clickToCopy: 'Click to copy URL',
        urlCopied: 'Image URL copied to clipboard!',
        copyFailed: 'Failed to copy URL. Please try manually.',
        fetchError: 'Failed to load images. Please try again later.',
        featureFlagDisabled: 'Image Bank feature is not enabled for your company.'
    },
    course: {
        untitled: 'Untitled Course',
        notFound: 'Course not found. Please check the URL or contact support.',
        fetchError: 'Failed to load course. Please try again later.',
        loading: 'Loading course...',
        error: 'Error loading course',
        error: {
            sessionDateRequired: 'Please set the course session date and time before assigning to organizations'
        }
    },
    assetBank: {
        title: 'Company Asset Bank',
        publicTitle: 'Public Asset Bank',
        noImages: 'No images found in the company asset bank.',
        noVideos: 'No videos found in the company asset bank.',
        clickToCopy: 'Click to copy URL',
        urlCopied: 'URL copied to clipboard!',
        copyFailed: 'Failed to copy URL. Please try manually.',
        fetchImageError: 'Failed to load images. Please try again later.',
        fetchVideoError: 'Failed to load videos. Please try again later.',
        imagesTab: 'Images',
        videosTab: 'Videos',
        featureFlagDisabled: 'Asset Bank feature is not enabled for your company.',
        addToChapterTooltip: 'Add to chapter',
        addToChapter: 'Add to Chapter',
        addAsBackgroundTooltip: 'Add as chapter background',
        addAsBackground: 'Add as Background',
        addedToChapter: (key, { type }) => `${type === 'image' ? 'Image' : 'Video'} added to chapter!`,
        addedAsBackground: 'Image added as chapter background!',
        addedAsBackgroundVideo: 'Video added as chapter background!',
        uploadImage: 'Upload Image',
        uploadVideo: 'Upload Video',
        uploadSuccess: 'File uploaded successfully',
        uploadError: 'Error uploading file',
        invalidFileType: 'Invalid file type',
        fileTooLarge: (key, { maxSize }) => `File is too large. Maximum size is ${maxSize}`
    },
    certifications: {
        category: 'Category',
        categoryForceCompletion: 'Required Task',
        categoryCertification: 'Certification',
        categoryKnowledgeCenter: 'Knowledge Center',
        categoryChangeDisabled: {
            multipleVersions: 'Cannot change category when multiple versions exist'
        },
        expiryDuration: {
            toggleLabel: 'Add Expiry to Certification',
            title: 'Certification Validity',
            valueLabel: 'Duration',
            unitLabel: 'Time Unit',
            units: {
                years: 'Years',
                months: 'Months',
                days: 'Days'
            },
            note: 'Set validity period for certification. The system will calculate expiry date from the certification completion date.'
        },
    },
    durationPicker: {
        label: 'Duration to complete',
        valueLabel: 'Amount',
        valuePlaceholder: 'Enter value',
        unitPlaceholder: 'Select unit',
        days: 'Days',
        months: 'Months',
        years: 'Years',
        MINUTES: 'Minutes',
        DAYS: 'Days',
        MONTHS: 'Months',
        YEARS: 'Years',
        errorInvalidValue: 'Please enter a positive number'
    },
    courseFields: {
        sessionStartDate: 'Session Start Date & Time',
        sessionDuration: 'Session Duration (minutes)',
        location: 'Location (address/room)',
        meetingLink: 'Meeting Link (Zoom/Google Meet)',
        instructor: 'Instructor Name',
        onlineSession: 'Online Session',
        invalidMeetingLink: 'Please enter a valid meeting link from a recognized platform (Zoom, Microsoft Teams, Google Meet, Webex, GoToMeeting, Jitsi, Whereby, etc.)',
    },
    selectDurationModal: {
        titleOrg: 'Set Duration for Organization',
        titleUser: 'Set Duration for User',
        durationLabel: 'Time to complete the task',
        explanation: 'Users will receive a deadline calculated from their assignment date. For example, if you set 60 days, a user assigned today will have 60 days to complete the task.'
    },
    addToHomeScreen: {
        title: 'Install the App',
        description: 'Install WeezBee on your device for faster access and better experience.',
        install: 'Install Now',
        dismiss: 'Got it, thanks!',
        neverAskAgain: 'Never show again',
        benefits: {
            faster: 'Faster access',
            offline: 'Works offline',
            homeScreen: 'Home screen shortcut'
        },
        iosInstructions: {
            title: 'To install the app on your iPhone:',
            step1Part1: 'Tap the "Share" button',
            step1Part2: '- found in the URL bar or menu',
            step2: 'Scroll down in the menu that opens',
            step3: 'Tap "Add to Home Screen"',
            step4: 'Tap "Add" in the top corner to finish'
        }
    }
};
